function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      const newPreviousvalue = Number(this.input.getAttribute('data-cart-quantity'));
  
      if (event.target.name === 'plus') {
        if (newPreviousvalue < 4) {
          this.input.stepUp();
        } else {
          alert("You can only Add 4 items");
        }
      } else {
        this.input.stepDown();
      }
  
      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    } 
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
    const thumbnailSwiper = window.thumbnailSwiper;
    const slectedVariantImageIndex = this.querySelector('input[type="radio"]:checked')?.getAttribute("data-image-index");
    if (slectedVariantImageIndex) {
      thumbnailSwiper.slideTo(parseInt(slectedVariantImageIndex))
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const productFromSource = html.querySelector(".custom-buy-buttons");
        const productFormDestination = document.querySelector(".custom-buy-buttons");
        const mediasource = html.querySelector(".product-media-gallery");
        const mediaDestination = document.querySelector(".product-media-gallery");
        const quantitySelectorSource = html.querySelector(".product-form__quantity");
        const quantitySelectorDestination = document.querySelector(".product-form__quantity")

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        if (productFormDestination && productFromSource) {
          productFormDestination.innerHTML = productFromSource.innerHTML;
        }

        if (mediaDestination && mediasource){
          mediaDestination.innerHTML = mediasource.innerHTML;
        }

        if (quantitySelectorSource && quantitySelectorDestination) {
          quantitySelectorDestination.innerHTML = quantitySelectorSource.innerHTML;
        }

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// timer
class CountDown extends HTMLElement {
  constructor() {
    super();
    this.initCountDown()
  }

  initCountDown() {
    this.endYear = parseInt(this.dataset.endyear);
    this.endMonth = parseInt(this.dataset.endmonth);
    this.endDay = parseInt(this.dataset.endday);
    this.endHour = parseInt(this.dataset.endhour);
    this.endMinute = parseInt(this.dataset.endminute);
    this.countdownFormat = this.dataset.countdownformat || "<span>Sale Ends In: </span>{daysElement}<span class='square'>{hours}</span> H <span class='square'>{minutes}</span> M <span class='square'>{seconds}</span> S";

    var countDownDate = new Date(this.endYear, this.endMonth, this.endDay, this.endHour, this.endMinute).getTime();

    // Update the count down every 1 second
    let offerCountDownData = {}

    offerCountDownData.countDownFunction = setInterval(() => {

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Initialize daysElement to an empty string
        var daysElement = '';

        // If days is greater than 0, include the {days} span
        if (days > 0) {
            daysElement = "<span class='square'>{days}</span> : ";
        }

        // Replace {daysElement} in countdownFormat
        this.innerHTML = this.countdownFormat.replace('{daysElement}', daysElement)
                                             .replace('{days}', days)
                                             .replace('{hours}', hours)
                                             .replace('{minutes}', minutes)
                                             .replace('{seconds}', seconds);

        // If the count down is finished, write some text
        if (distance < 0) {
            clearInterval(offerCountDownData.countDownFunction);
            this.innerHTML = "FLASHSALE END";
            this.classList.add("hidden");
        }
    }, 1000);
  }


}

customElements.define('count-down', CountDown);	

// scroll buttons in PDP Also Available In section
class ScrollButtons extends HTMLElement {
  connectedCallback() {
    this.querySelector('.left-btn').addEventListener('click', this.scrollToLeft.bind(this));
    this.querySelector('.right-btn').addEventListener('click', this.scrollToRight.bind(this));
  }

  scrollToLeft() {
    const container = document.getElementById('alsoAvailableContainer');
    container.scrollBy({
      left: -container.offsetWidth,
      behavior: 'smooth'
    });
    this.querySelector('.left-btn').style.display = 'none';
    this.querySelector('.right-btn').style.display = 'flex';
  }

  scrollToRight() {
    const container = document.getElementById('alsoAvailableContainer');
    container.scrollBy({
      left: container.offsetWidth,
      behavior: 'smooth'
    });
    this.querySelector('.left-btn').style.display = 'flex';
    this.querySelector('.right-btn').style.display = 'none';
  }
}

customElements.define('scroll-buttons', ScrollButtons);

// Also Available in GA event for page view
function handleAlsoAvailableClick(event, element) {
  event.preventDefault();

  var eventData = {
    ProductTitle: element.dataset.title,
    ProductPrice: element.dataset.price/100,
    ProductSKU: element.dataset.sku,
    ProductURL: `${element.dataset.shopurl}${element.dataset.url}`
  };


  if (typeof dataLayer !== 'undefined') {
    dataLayer.push({
      'event': 'Also Available In viewed',
      clevertap: eventData
    });
  } else {
    console.error('dataLayer is not defined');
  }

  window.location.href = element.getAttribute('href');
  return false;
}

// empty cart collection page view GA event

document.querySelectorAll(".ec_collection a").forEach((e)=>{
  e.addEventListener("click",()=>{
      const targetCollection = e.getAttribute('data-collectionName');
      const targeCollectionUrl = e.getAttribute('href');
      dataLayer.push({
        event: "Empty Cart Collection",
        CollectionName: targetCollection,
        PageURL: `https://letshyphen.com/collections${targeCollectionUrl}`
      });
  })
})

// section lazy loading
class LazySection extends HTMLElement {
  static sectionsToFetch = [];

  constructor() {
    super();

    this.section = this.closest('section')?.id || this.closest('[id]').id;
    this.section = this.section?.replace('shopify-section-', '');

    this.trigger = this.dataset.triggerEvent || 'intersection-observer';
    this.targetSelector = this.dataset.triggerTarget || 'body';

    this.boundHandleMouseover = this.handleMouseover.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    const targetElement = document.querySelector(this.targetSelector);

    // Different triggers based on data-trigger attribute
    if (this.trigger === 'mouseover') {
      if (screen.width < 990) return;
      
      targetElement.addEventListener('mouseover', this.boundHandleMouseover);
    } else if (this.trigger === 'click') {
      targetElement.addEventListener('click', this.boundHandleClick);
    } else {
      // Default to intersection observer
      new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  // Handler for intersection-observer trigger
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.fetchSections();
  }

  // Handler for mouseover trigger
  handleMouseover() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Handler for click trigger
  handleClick() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Common function for fetching sections
  fetchSections() {
    LazySection.sectionsToFetch.push(this.section);
    const sectionsToFetchBatch = LazySection.sectionsToFetch.length == 5 ? LazySection.sectionsToFetch.splice(0, 5) : LazySection.sectionsToFetch;

      // Check if there is an ongoing network request
    if (LazySection.abortController) {
      LazySection.abortController.abort();
    }

    LazySection.abortController = sectionsToFetchBatch.length < 5 && new AbortController();

    fetch(window.location.pathname + '?sections=' + sectionsToFetchBatch.join(','), LazySection.abortController.signal ? { signal: LazySection.abortController.signal } : {})
      .then((response) => response.json())
      .then((json) => {
        for (const [key, value] of Object.entries(json)) {
          const sectionContent = new DOMParser().parseFromString(value, 'text/html').getElementById('shopify-section-' + key);

          if (sectionContent && sectionContent.innerHTML.trim().length) {
            const section = document.getElementById('shopify-section-' + key);
            section.innerHTML = sectionContent.innerHTML;

              // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
            section.querySelectorAll('script').forEach((oldScriptTag) => {
              const newScriptTag = document.createElement('script');
              Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
              });
              newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
          }
        }

        if (sectionsToFetchBatch.length < 5)
          LazySection.sectionsToFetch = [];
      })
      .catch((e) => {
        console.warn(e);
      });
  }

  // Remove trigger based on data-target attribute
  removeTrigger() {
    const targetElement = document.querySelector(this.targetSelector);

    if (targetElement) {
      targetElement.removeEventListener('mouseover', this.boundHandleMouseover);
      targetElement.removeEventListener('click', this.boundHandleClick);
    }
  }
}

customElements.define('lazy-section', LazySection);

// random  number

class RandomNumber extends HTMLElement {
  constructor() {
      super();
      this.replaceRandom();
  }

  generateRandomNumber(start, end) {
      return Math.floor(Math.random() * (end - start + 1)) + start;
  }

  replaceRandom() {
      const sessionKey = 'randomNumber';
      let random = sessionStorage.getItem(sessionKey);

      if (!random) {
          const start = parseInt(this.getAttribute('data-start'), 10);
          const end = parseInt(this.getAttribute('data-end'), 10);
          random = this.generateRandomNumber(start, end);
          sessionStorage.setItem(sessionKey, random);
      }
      const randomSpan = `<span>${random}</span>`
      const inventoryMessage = this.querySelector('.inventory_message');
      if (inventoryMessage) {
          inventoryMessage.innerHTML = inventoryMessage.innerHTML.replace('[random]', randomSpan);
      }
  }
}

customElements.define('random-number', RandomNumber);

// sticky header

document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header-sticky');
  const headerHeight = header.offsetHeight + 50;

  window.addEventListener('scroll', function() {
      if (window.scrollY > headerHeight) {
          header.classList.add('sticky');
      } else {
          header.classList.remove('sticky');
      }
  });
});

// pdp color swatch

class customColorSwatch extends HTMLElement {
	constructor() {
		super();
		// this.addEventListener('click', this.scrollToTop);
	}

	connectedCallback() {
		let _this = this;
		let colorSwatchContainer = this.querySelectorAll('custom-color-swatch .image_container');
		colorSwatchContainer.forEach((item) => {
			item.addEventListener('click', function () {
				_this.colorSwatch(item);
			});
		});
	}

	// scrollToTop() {
	// 	window.scrollTo({
	// 		top: 0,
	// 		behavior: 'smooth',
	// 	});
	// }

	// Color swatch logic function
	colorSwatch(item) {
		var dataUrl = item.getAttribute('data-product-url');

		// Change URL using history state
		history.replaceState(
			{
				id: 'newproduct',
				source: 'web',
			},
			'newproduct',
			'https://letshyphen.com' + dataUrl,
		);

		// Fetch section id's
		var sectionIds = [];

		document.querySelectorAll('.product-section').forEach(function (element) {
			sectionIds.push(element.dataset.section);
		});

		let mainContentEl = document.getElementById('MainContent');
		let urls = [];

		const sectionsPerArray = 5;
		const totalSections = sectionIds.length;
		const totalArrays = Math.ceil(totalSections / sectionsPerArray);

		// Divide section IDs into arrays of sectionsPerArray length
		for (let i = 0; i < totalArrays; i++) {
			let startIndex = i * sectionsPerArray;
			let endIndex = startIndex + sectionsPerArray;
			let currentArray = sectionIds.slice(startIndex, endIndex);
			let currentUrl = 'https://letshyphen.com/' + dataUrl + '/?sections=' + currentArray.join(',');
			urls.push(currentUrl);
		}

		// Fetch data for each URL asynchronously
		var promises = urls.map((url) => fetch(url).then((y) => y.json()));

		Promise.all(promises).then((results) => {
			// Spreading Multiple response JSON into a single JSON object
			let allsections = Object.assign({}, ...results);

			// Clear the main content element
			mainContentEl.innerHTML = '';

			// Append each section to the main content element
			for (const property in allsections) {
				mainContentEl.innerHTML += allsections[property];
			}
      //Reinitializing dEventListener
      document.querySelectorAll(".read_toggle").forEach(x=>{
          x.addEventListener("click",e=>{
              if(e.target.innerText.includes("More")){
                  e.target.parentElement.querySelector(".real_content").style.display="none";
                      e.target.parentElement.querySelector(".fullcontent").style.display="block";
                  e.target.innerText = "Read Less!";
              }else{
                  e.target.innerText = "Read More...";
                  e.target.parentElement.querySelector(".real_content").style.display="block";
                      e.target.parentElement.querySelector(".fullcontent").style.display="none";
              }
          })
      })
		});
	}
}

customElements.define('custom-color-swatch', customColorSwatch);

// image popup

class AnnouncementPopup extends HTMLElement {
  constructor(){
    super();
    this.renderAnnouncementPopup();
  }

  renderAnnouncementPopup(){
    const popupDelayTime = parseInt(this.dataset.delayTime) * 1000;
    const popupDisplayTime = popupDelayTime + (parseInt(this.dataset.displayTime) * 1000);
    const homePopup = sessionStorage.getItem('home-popup');

    if (homePopup !== 'continue') {
      setTimeout(() => {
        this.classList.add('is-visible');
        let sectionTitle = this.getAttribute('data-title') || "NA"
        let popupLink = this.getAttribute('data-image-link') || "NA";
        dataLayer.push({
          event: "Popup",
            "Popup Title": sectionTitle,
            "Popup image link": popupLink,
            "Landing page": window.location.href
          });
      }, popupDelayTime);

      setTimeout(() => {
        this.classList.remove('is-visible');
      }, popupDisplayTime);

      sessionStorage.setItem('home-popup', 'continue');
    }
  }
}

customElements.define('announcement-popup', AnnouncementPopup);

// bundle product banner

class ProductsBundle extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.addEventListener('click', this.addBundleProductsToCart.bind(this));
  }

  addBundleProductsToCart() {
    const productsList = this.querySelectorAll(".bundle-product");
    let items = [];
    let titleArray = [];
    let valueArray = [];
    let sectionTitle;
    
    productsList.forEach((product) => {
      items.push({'id': product.dataset.bundleProduct, 'quantity': 1, 'properties': {offer: product.dataset.offer}});
      titleArray.push(product.dataset.title);
      valueArray.push(product.dataset.value/100);
      sectionTitle = product.dataset.sectionTitle || "NA";
    })
    dataLayer.push({
      event: "banner_click",
      products: {
        title: titleArray.join(', '),
        value: valueArray.join(', ')
      },
      section_title: sectionTitle
    });


    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const bundleData = {"items": items};

    if (this.cart) {
      bundleData['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
      bundleData['sections_url'] = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = JSON.stringify(bundleData);

    fetch('/cart/add.js', config)
    .then(response => response.json())
    .then(data => {
      this.cart.renderContents(data)
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      if (this.cart && this.cart.classList.contains("is-empty"))
        this.cart.classList.remove("is-empty");
    })
  }
}

customElements.define('products-bundle', ProductsBundle);

class CategoryTab extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback(){
    let tabButtons = this.querySelectorAll(".category-tab-content-tab-button");
    
    tabButtons.forEach((button) => {
      button.addEventListener("click",()=>{
        this.switchContent(button);
      })
    });
  }

  switchContent(button){
    let index = button.getAttribute("data-index");
    let prevActiveButton = this.querySelector(".active-tab-button")
    let prevActiveContent = this.querySelector(".show-content");
    let presentActiveContent = this.querySelector(`.category-tab-content-${index}`);

    this.addDataLayerEvent(button,presentActiveContent);

    prevActiveContent.classList.remove("show-content");
    setTimeout(() => {
      prevActiveContent.closest(".category-tab-content-wrapper").classList.add("hidden");
      presentActiveContent.closest(".category-tab-content-wrapper").classList.remove("hidden");
    }, 400);
    setTimeout(() => {
      presentActiveContent.classList.add("show-content");
    }, 500);
    prevActiveButton.classList.remove("active-tab-button");
    button.classList.add("active-tab-button");
  }

  addDataLayerEvent(button,content){
    let leftBannerImg = content.querySelector(".category-tab-content--image-wrapper img").src;
    let categoryLink = button.getAttribute("data-collection-link");
    let producCards=content.querySelectorAll(".card-wrapper");
    let productsName = [];

    producCards.forEach((card)=>{
      productsName.push(card.querySelector(".card__heading a").innerText.trim());
    })

    let clevertapData = {
      Category_Name: button.innerText,
      Category_Link :categoryLink, 
      Left_Banner_Img : leftBannerImg,
      Products_Name : productsName.join(","),
    }

    dataLayer.push({
      event: "Category_tab",
      Category_Name: button.innerText,
      Category_Link :categoryLink, 
      Left_Banner_Img : leftBannerImg,
      Products_Name : productsName.join(","),
      clevertap : clevertapData
    });
  }
}

customElements.define('category-tab', CategoryTab);

// GA4 and CT events for Mobile bottom Navigation
document.addEventListener("DOMContentLoaded", () => {
  let mobileNavButtons = document.querySelectorAll(".mobile-bottom-nav--item");
  let cartValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value");

  mobileNavButtons.forEach((item) => {
    item.addEventListener("click", () => {
      let clevertapData = {
        Nav_Item_Name : item.querySelector(".mobile-bottom-nav-item--text").innerText || '',
        Current_Page : window.location.href || '',
        Nav_Item_Link : item.querySelector("a").href || '',
        Cart_Value : cartValue.innerHTML,
      }
      
      dataLayer.push({
        event: "Bottom_Nav",
        Nav_Item_Name : item.querySelector(".mobile-bottom-nav-item--text").innerText || '',
        Current_Page : window.location.href || '',
        Nav_Item_Link : item.querySelector("a").href || '',
        Cart_Value : cartValue.innerHTML,
        clevertap : clevertapData
      });
    });
  });
});

class ShopByConcern extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback(){
    let shopByConcernItems = this.querySelectorAll(".shop-by-concern--item");
    let cartValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value");
  
    shopByConcernItems.forEach(item=>{
      item.addEventListener("click",()=>{
        dataLayer.push({
          event: "Category_Click",
          Section_Name : item.getAttribute("data-Section-Name") || '',
          Block_Image : item.querySelector("img").src || '',
          Block_Title : item.getAttribute("data-block-title") || '',
          Block_Link : item.href,
          Cart_Value : cartValue.innerHTML
        });
    
        if(typeof clevertap != "undefined"){
          clevertap.event.push("Category_Click",{
            Section_Name : item.getAttribute("data-Section-Name") || '',
            Block_Image : item.querySelector("img").src || '',
            Block_Title : item.getAttribute("data-block-title") || '',
            Block_Link : item.href,
            Cart_Value : cartValue.innerHTML
          });
        }
      })
    })
  }
}

customElements.define('shop-by-concern', ShopByConcern);

class FeedbackForm extends HTMLElement {
  constructor() {
    super();
    this.formWrapper = this.querySelector(".feedback-form__wrapper");
    this.form = this.querySelector(".feedback-form__form");
    this.inputElementsList = this.querySelectorAll('.feedback-form__form input');
    this.submitButton = this.querySelector(".feedback-form__submit-button");
    this.spinnerWrapper = this.querySelector(".feedback-form__spinner-wrapper");
    this.submitResponse = this.querySelector(".feedback-form__submit-response-wrapper");

    this.form.addEventListener('submit', this.sendDataToGoogleSheet.bind(this));
  }

  connectedCallback() {
    this.adjustPaddingOnLoad();
    this.addInputEventListeners();
  }

  adjustPaddingOnLoad() {
    this.inputElementsList.forEach(inputElement => {
      this.adjustPaddingForInput(inputElement);
    });
  }

  adjustPaddingForInput(inputElement) {
    const labelElement = this.querySelector(`label[for="${inputElement.id}"]`);

    if (labelElement) {
      const labelHeight = labelElement.offsetHeight;
      const additionalPadding = labelHeight - 22;
      inputElement.style.paddingTop = `${additionalPadding}px`;

      if (inputElement.value.trim() !== "") {
        inputElement.classList.add("has-text");
      }
      else {
        inputElement.classList.remove("has-text");
      }
    }

    this.classList.remove("hide-form");
  }

  handleBlurEvent(inputElement) {
    this.validateInput(inputElement);
  }

  validateInput(inputElement) {
    const fieldName = inputElement.name.toLowerCase();
    const value = inputElement.value.trim();
    let isValid = true;
    let errorMessage = "";

    if (fieldName === "name" && value !== "") {
      const nameRegex = /^[a-zA-Z\s]+$/;

      if (!nameRegex.test(value)) {
        isValid = false;
        errorMessage = "*Name must only contain letters and spaces.";
      }
    }
    else if (fieldName === "email" && value !== "") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(value)) {
        isValid = false;
        errorMessage = "*Please enter a valid email address.";
      }
    }
    else if (value === ""){
      isValid = false;
      errorMessage = "*Field cannot be empty";
    }

    if (!isValid) {
      this.showValidationError(inputElement, errorMessage);
    } 
    else {
      this.clearValidationError(inputElement);
    }
  }

  showValidationError(inputElement, message) {
    const parentElement = inputElement.parentElement;
    const errorMessage = parentElement.nextElementSibling;
    errorMessage.textContent = message;
    inputElement.classList.add("input-error");
  }

  clearValidationError(inputElement){
    const parentElement = inputElement.parentElement;
    const errorMessage = parentElement.nextElementSibling;
    errorMessage.textContent = "";
    inputElement.classList.remove("input-error");
  }

  addInputEventListeners() {
    this.inputElementsList.forEach(inputElement => {
      inputElement.addEventListener('focus', () => this.adjustPaddingForInput(inputElement));
      inputElement.addEventListener('blur', () => this.handleBlurEvent(inputElement));
      inputElement.addEventListener('input', () => this.adjustPaddingForInput(inputElement));
    });
  }

  sendDataToGoogleSheet(event) {
    event.preventDefault();
    this.spinnerWrapper.classList.remove('hide-loader');
    const url = "https://script.google.com/macros/s/AKfycbxbz6rVKqoHOjo8umRbEuWpcYjLbJqgrDxAU2xaCnets4k0yVGestFLYrxd60I0JWLyzQ/exec";

    const formData = new FormData();
    let isValidForm = true;
    
    if (this.inputElementsList) {
      this.inputElementsList.forEach((inputElement) => {
        this.validateInput(inputElement);
        formData.append(inputElement.name, inputElement.value.trim(" "));
        
        if (inputElement.classList.contains('input-error')) {
          isValidForm = false;
        }
      });
    }

    if (!isValidForm) {
      this.spinnerWrapper.classList.add('hide-loader');
      return;
    }

    try {
      fetch(url, {
        method: 'POST',
        body: formData
      }).then(response => {
        if (response.ok) {
          this.formWrapper.classList.add("hide-form-wrapper");
          this.spinnerWrapper.classList.add('hide-loader');
          this.submitResponse.classList.remove("hide-submit-status");
        } 
        else {
          console.error('Error in response:', response.statusText);
        }
      });
    } catch (error) {
      console.error('Error sending data:', error);
    }
  }
}

customElements.define('feedback-form', FeedbackForm);

class BogoPopup extends HTMLElement {
  constructor() {
    super();
    this.mobileNumberElement = this.querySelector('.bogo-popup__content-wrapper input');
    this.overlayContainer = this.querySelector(".bogo-popup__overlay-container");
    this.contentWrapper = this.querySelector(".bogo-popup__content-wrapper");
    this.navigationButton = this.querySelector(".bogo-popup__buttons-wrapper a");
    this.closePopupButton = this.querySelector(".bogo-popup__close-button");
    this.closePopupTextButton = this.querySelector(".bogo-popup__buttons-wrapper button");

    if (this.getAttribute("data-enable-input") == 'true') {
      this.mobileNumberElement.addEventListener('input', this.validateMobileNumber.bind(this));
      this.navigationButton.addEventListener('click', this.sendDataToGoogleSheet.bind(this));
    }

    this.overlayContainer.addEventListener('click', this.handleOverlayClick.bind(this));
    this.closePopupButton.addEventListener('click', this.closeBogoPopup.bind(this));
    if (this.closePopupTextButton) {
      this.closePopupTextButton.addEventListener('click', this.closeBogoPopup.bind(this));
    }
  }

  connectedCallback() {
    const isBogoPopupDisplayed = sessionStorage.getItem("bogo-popup-shown");
    const delayTime = parseInt(this.dataset.popupDelayTime) * 1000;
    const displayTime = (parseInt(this.dataset.popupDisplayTime) * 1000) + delayTime;

    if (isBogoPopupDisplayed === null || isBogoPopupDisplayed === false) {
      setTimeout(() => {
        this.classList.remove("hide-bogo-popup");
        this.submitDatalayerEvents(this);
      }, delayTime);


      this.timerId = setTimeout(() => {
        this.classList.add("hide-bogo-popup");
        sessionStorage.setItem('bogo-popup-shown', true);
      }, displayTime)
    }

    if (this.getAttribute("data-enable-input") == 'true') {
      this.navigationButton.classList.add('disabled');
      this.navigationButton.style.pointerEvents = "none";
    }
  }

  handleOverlayClick(event) {
    if (!this.contentWrapper.contains(event.target)) {
      this.closeBogoPopup();
    }
  }

  closeBogoPopup() {
    this.overlayContainer.classList.add('hide-bogo-popup');
    sessionStorage.setItem('bogo-popup-shown', true);

    const clevertapData = {
      'Landing_Page': this.getAttribute("data-button-url") || '',
      'Current_Page': this.getAttribute("data-current-page") || '',
      'Cart_Value': document.querySelector(".cart-discounted-price").textContent || '',
      'Button_Text' : this.getAttribute("data-button") || ''
    }

    dataLayer.push({
      'event': "Popup_Cta_Close",
      'Landing_Page': this.getAttribute("data-button-url") || '',
      'Current_Page': this.getAttribute("data-current-page") || '',
      'Cart_Value': document.querySelector(".cart-discounted-price").textContent || '',
      'Button_Text' : this.getAttribute("data-button") || '',
      clevertap: clevertapData 
    });

  }

  validateMobileNumber() {
    clearTimeout(this.timerId)
    const mobileNumber = this.mobileNumberElement.value;
    const errorMessage = this.querySelector('.bogo-popup__error-message');
  
    if (mobileNumber.length === 10 && /^\d{10}$/.test(mobileNumber)) {
      this.navigationButton.classList.remove('disabled');
      this.navigationButton.style.pointerEvents = "auto";
      if (errorMessage) errorMessage.textContent = "";
    } else {
      this.navigationButton.classList.add('disabled');
      this.navigationButton.style.pointerEvents = "none";
  
      if (mobileNumber.length > 0) {
        if (mobileNumber.length < 10) {
          errorMessage.textContent = "*Number must be 10 digits.";
        } else if (mobileNumber.length > 10) {
          errorMessage.textContent = "*Number cannot exceed 10 digits.";
        }
      }
    }
  }
  

  sendDataToGoogleSheet() {

    const clevertapData = {
      'Landing_Page': this.getAttribute("data-button-url") || '',
      'Current_Page': this.getAttribute("data-current-page") || '',
      'Cart_Value': document.querySelector(".totals__subtotal-value").textContent || '',
      'Button_Text' : this.getAttribute("data-button") || ''
    }

    dataLayer.push({
      'event': "Popup_Cta_Clicked",
      'Landing_Page': this.getAttribute("data-button-url") || '',
      'Current_Page': this.getAttribute("data-current-page") || '',
      'Cart_Value': document.querySelector(".totals__subtotal-value").textContent || '',
      'Button_Text' : this.getAttribute("data-button") || '',
      clevertap: clevertapData 
    });

    const mobileNumber = this.mobileNumberElement.value;
    const url = "https://script.google.com/macros/s/AKfycbza_fg96VRIhQJMDFwQH6Dr21DaSC7uZ2jRFeI_SarUrvudbEIGb7H9UirIvYyxwPU3oQ/exec"
    const formData = new FormData();
    formData.append('Mobile Number', mobileNumber);

    try {
      fetch(url, {
        method: 'POST',
        body: formData
      })
    } 
    catch (error) {
      console.error('Error sending data:', error);
    }
  }

  submitDatalayerEvents(popup) {

    const clevertapData = {
      'Image': popup.getAttribute("data-image") || '',
      'Header_Communication': popup.getAttribute("data-title") || '',
      'Subtext_communication': popup.getAttribute("data-sub-text")  || '',
      'Button_Text' : popup.getAttribute("data-button") || ''
    }

    dataLayer.push({
      'event': "Offer_Popup",
      'Image': popup.getAttribute("data-image") || '',
      'Header_Communication': popup.getAttribute("data-title") || '',
      'Subtext_communication': popup.getAttribute("data-sub-text") || '',
      'Button_Text' : popup.getAttribute("data-button") || '',
      clevertap: clevertapData 
    });
  }

}

customElements.define('bogo-popup', BogoPopup);

document.addEventListener("DOMContentLoaded", function() {
  let tcPopup = document.querySelector(".tc_popup-overlay-container");

  if (tcPopup) {
    document.querySelector(".tc_popup-button").addEventListener("click",()=>{
      tcPopup.classList.remove("hidden");
  
      setTimeout(() => {
        tcPopup.querySelector(".tc_popup").classList.add("active");
      }, 100);
    })
  
    tcPopup.addEventListener("click",() => {
      tcPopup.querySelector(".tc_popup").classList.remove("active");
  
      setTimeout(() => {
        tcPopup.classList.add("hidden");
      }, 500);
    })
  }
})

class CategoriesSelection extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback(){
    let categories = this.querySelectorAll(".image-text-grid--block");
    let cartValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value");

    categories.forEach(item=>{
      item.addEventListener("click",()=>{
        let clevertapData = {
          Category_Name : item.getAttribute("data-category-name") || '',
          Category_Image : item.querySelector(".image-text-grid-block--image img").src || '',
          Category_Link : item.querySelector("a").href || '',
          Cart_Value : cartValue.innerHTML
        }

        dataLayer.push({
          event: "Category_Page_Selection",
          Category_Name : item.getAttribute("data-category-name") || '',
          Category_Image : item.querySelector(".image-text-grid-block--image img").src || '',
          Category_Link : item.querySelector("a").href || '',
          Cart_Value : cartValue.innerHTML,
          clevertap : clevertapData
        });
      })
    })
  }
}

customElements.define('categories-selection', CategoriesSelection);

class BannerCarousel extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback(){
    let desktopBanner = this.querySelectorAll(".desk-img-anti");
    let mobileBanner = this.querySelectorAll(".mob-img-anti");;

    desktopBanner.forEach((banner)=>{
      banner.addEventListener("click",()=>{
        let clevertapData = {
          Section_Title : this.getAttribute("data-section-title") || '',
          Block_Image : banner.querySelector("img").src || '',
          Block_title : banner.getAttribute("data-block-heading") || ''
        }

        dataLayer.push({
          event: "Web_Banner",
          Section_Title : this.getAttribute("data-section-title") || '',
          Block_Image : banner.querySelector("img").src || '',
          Block_title : banner.getAttribute("data-block-heading") || '',
          clevertap : clevertapData
        });
      })
      
    })

    mobileBanner.forEach((banner)=>{
      banner.addEventListener("click",()=>{
        let clevertapData = {
          Section_Title : this.getAttribute("data-section-title") || '',
          Block_Image : banner.querySelector("img").src || '',
          Block_title : banner.getAttribute("data-block-heading") || ''
        }

        dataLayer.push({
          event: "Web_Banner",
          Section_Title : this.getAttribute("data-section-title") || '',
          Block_Image : banner.querySelector("img").src || '',
          Block_title : banner.getAttribute("data-block-heading") || '',
          clevertap : clevertapData
        });
      })
      
    })
  }
}

customElements.define('banner-carousel', BannerCarousel);

const visitedUrls = JSON.parse(sessionStorage.getItem("visitedUrls")) || [];
if (visitedUrls[visitedUrls.length-1] != window.location.href){
  visitedUrls.push(window.location.href);
  sessionStorage.setItem("visitedUrls", JSON.stringify(visitedUrls));
}

class ProductQuiz extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.response = {};
    this.productCombos = JSON.parse(this.getAttribute("data-product-combination"));
    this.loader = this.querySelector(".quiz-recommendation-container .card-loader");
    this.backButtons=this.querySelectorAll(".quiz_question .back");
    this.initializeResponse(); 

    ['option1', 'option2', 'option3','option4'].forEach(optionName => this.addOptionChangeListener(optionName));

    this.backButtons.forEach((button)=>{
      button.addEventListener("click",()=>{
        const question = button.closest(".quiz_question");
        const options = question.querySelectorAll(".option");

        question.classList.add("hidden");
        
        options.forEach((option)=>{
          option.classList.add("inactive");
        })
        this.showNextQuestion(button.getAttribute("data-prev"));
      });
    });

    this.defaultProducts = JSON.parse(this.getAttribute("data-default-products"));
    this.datalayerEvents("Quiz_Start");
  }

  initializeResponse() {
    this.response = {
      skin_type: this.getSelectedValue('option1'),
      skin_sensitive: this.getSelectedValue('option2'),
      main_concern: this.getSelectedValue('option3'),
      product_type : this.getSelectedValue('option4')
    };
  }

  getSelectedValue(optionName) {
    const selectedOption = this.querySelector(`input[name="${optionName}"]:checked`);
    return selectedOption ? selectedOption.value : null;
  }

  addOptionChangeListener(optionName) {
    const options = this.querySelectorAll(`input[name="${optionName}"]`);
    options.forEach(radio => radio.addEventListener('click', (event) => this.handleOptionChange(event, optionName)));
  }

  handleOptionChange(event, optionName) {
    const responseKey = this.getResponseKey(optionName);
    this.response[responseKey] = event.target.value;
    const nextQuestion = event.target.closest(".quiz_question").getAttribute("data-next");
    const presentQuestion = event.target.closest(".quiz_question");
    const presentOptions = presentQuestion.querySelectorAll(".option");
    const lastQuestion = this.querySelector(".last-question");
    const resultContainer = this.querySelector(".quiz-recommendation-container");
    
    if (nextQuestion) {
      setTimeout(() => {
        presentQuestion.classList.add("hidden");

        presentOptions.forEach((option)=>{
          option.classList.add("inactive");
        })

        this.showNextQuestion(nextQuestion);
      }, 500);
    } else {
      setTimeout(() => {
        lastQuestion.classList.add("hidden");
        let lastQuestionNumber = parseInt(lastQuestion.getAttribute("data-last-question"));
        this.updateProgressBar(lastQuestionNumber+1);

        presentOptions.forEach((option)=>{
          option.classList.add("inactive");
        });
  
        resultContainer.classList.remove("hidden");
        this.findProduct();
      }, 500);
    }
  }

  showNextQuestion(nextQuestion) {
    const question = this.querySelector(`.${nextQuestion}`);
    let options = question.querySelectorAll(".option");
    let questionNumber = parseInt(nextQuestion.slice(-1), 10); 
    let hideOption = question.querySelector("#oil-control");
    let delay = 0 ;

    if(this.response.skin_type == "dry" && hideOption ) {
      let oilyOption = hideOption.closest(".option");
      oilyOption.classList.add("hidden");
    } else if (hideOption && hideOption.classList.contains("hidden")) {
      let oilyOption = hideOption.closest(".option");
      oilyOption.classList.remove("hidden");
    }

    question.classList.remove("hidden");
    this.updateProgressBar(questionNumber);

    options.forEach((option)=>{
      delay += 100;
      setTimeout(() => {
        option.classList.remove("inactive");
      }, delay);
    })
  }

  updateProgressBar(goalNumber) {
    const progressbar = this.querySelector(".quiz-progress-bar-filled");
    const goals = this.querySelectorAll(".goal");
    const totalGoal = goals.length;
    const barIncreasePercent = 100/(totalGoal-1);
    let index = 0;
    let progressWidths = {};

    for (let i = 2; i <= totalGoal; i++) {
      let barWidth = (i-1)*barIncreasePercent<100 ? (i-1)*barIncreasePercent : 100; 
      progressWidths[i] = `${barWidth}%` ;
    }

    const heading = document.getElementById('quizHeading');
    const offset = window.innerHeight * 0.2; 
    const headingPosition = heading.getBoundingClientRect().top + window.scrollY; 
    
    window.scrollTo({
      top: headingPosition - offset, 
      behavior: 'smooth'
    });

    progressbar.style.width = progressWidths[goalNumber] || '0%';

    goals.forEach((goal)=>{
      goal.classList.remove("filled");
    })

    goals.forEach((goal)=>{
      index++;
      if(index <= goalNumber) {
        goal.classList.add("filled");
      }
    })

  }

  getResponseKey(optionName) {
    const mapping = {
      option1: "skin_type",
      option2: "skin_sensitive",
      option3: "main_concern",
      option4: "product_type"
    };
    return mapping[optionName];
  }

  async findProduct() {
    let resultCombo = this.productCombos.find(combo =>
      this.response.skin_type === combo.skin_type &&
      this.response.skin_sensitive === combo.skin_sensitive &&
      this.response.main_concern === combo.main_concern &&
      this.response.product_type === combo.product_type
    );
    if (resultCombo && resultCombo.recommended_product_List.length > 0 ) {
      let resultProductCards = "";
      for (const item of resultCombo.recommended_product_List) {
        const product = await this.fetchProductData(item);
        if (product) {
          resultProductCards += await this.constuctCard(product);
        }
      }
      this.showProduct(resultProductCards);
    } else if (!resultCombo) {
      const productType = this.response.product_type; 
      const defaultProduct = this.defaultProducts[productType];

      const product = await this.fetchProductData(defaultProduct);

      if (product) {
        let resultProductCards = await this.constuctCard(product);
        this.showProduct(resultProductCards);
      }
    } else {
      this.querySelector(".quiz-recommendation-container .card-loader").classList.add("hidden");
      this.querySelector(".quiz-recommendation-container .result-product-card").innerHTML="<div>Sorry no product found</div><div class='restart-quiz'>Retake Quiz</div>";
      this.querySelector(".restart-quiz").addEventListener("click",()=>{
        this.restartQuiz();
      })
    }
  }

  async fetchProductData(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error("Product not found");
      return await response.json();
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async constuctCard(product) {
    try {
      const cardProductUrl = `/products/${product.handle}?view=card-product`;
      const renderedHTML = await this.fetchRenderedHTML(cardProductUrl);

      if (renderedHTML) {
        return renderedHTML ;
      }
    } catch (error) {
      console.error('Error fetching product card:', error);
    }
  }

  showProduct(productCards) {
    if (productCards) {
      const container = this.querySelector('.quiz-recommendation-container');
      const productDiv =   container.querySelector(".result-product-card");
      container.querySelector(".card-loader").classList.add("hidden");
      
      productDiv.innerHTML = productCards;

      const resultTitle = document.createElement('div');
      resultTitle.className = 'result-title';
      resultTitle.textContent = 'Our Recommendation For You';
      productDiv.prepend(resultTitle);

      const restartDiv = document.createElement('div');
      restartDiv.className = 'restart-quiz';
      restartDiv.textContent = 'Retake Quiz';
      productDiv.appendChild(restartDiv);

      restartDiv.addEventListener("click",()=>{
        this.restartQuiz();
      });

      let productLinks = this.querySelectorAll(".result-product-card .quiz-product-link");

      productLinks.forEach((item)=>{
        item.addEventListener("click",()=>{
          let allOptions = this.querySelectorAll(".quiz-questions .option input");
          allOptions.forEach((option)=>{
            option.checked = false;
          });
          this.datalayerEvents("View_Product",item.closest(".quiz-product-card"));
        })
      });
      this.datalayerEvents("Quiz_Complete")
    }
  }

  async fetchRenderedHTML(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch product card template');
    return await response.text();
  }

  restartQuiz() {
    let resultContainer = this.querySelector(".quiz-recommendation-container");
    let allQuestions = this.querySelectorAll(".quiz_question");
    let allOptions = this.querySelectorAll(".quiz-questions .option input");
    let firstQuestion = this.querySelector(".quiz_question-1");
    let firstOptions = firstQuestion.querySelectorAll(".option");
    let delay = 0;

    resultContainer.classList.add("hidden");
    resultContainer.querySelector(".card-loader").classList.remove("hidden");
    resultContainer.querySelector(".result-product-card").innerHTML=" ";


    allOptions.forEach((option)=>{
      option.checked = false;
    });

    allQuestions.forEach((question)=>{
      question.classList.add("hidden");
    });    

    firstQuestion.classList.remove("hidden");
    this.updateProgressBar(1);

    firstOptions.forEach((option)=>{
      delay += 100;
      setTimeout(() => {
        option.classList.remove("inactive");
      }, delay);
    }); 
  }

  datalayerEvents(parameter,productCard) {
    const cartValue = document.querySelector(".totals__subtotal-value")?document.querySelector(".totals__subtotal-value").innerHTML:"";
    const visitedUrls = sessionStorage.getItem("visitedUrls");
    const urlArray = JSON.parse(visitedUrls);
    const lastUrl = urlArray[urlArray.length - 2];

    if (parameter=='Quiz_Start') {
      let clevertapData = {
        Current_Cart_Value : cartValue,
        Previous_Page : lastUrl
      }

      dataLayer.push({
        event: "Quiz_Start",
        Current_Cart_Value : cartValue,
        Previous_Page : lastUrl,
        clevertap : clevertapData
      });
    } else if (parameter=="Quiz_Complete") {
      const productNames = this.querySelectorAll(".quiz-product-card .quiz-product-title"); 
      const productNamesArray = Array.from(productNames).map(name => name.getAttribute("data-title"));
      const productPrice = this.querySelectorAll(".quiz-product-card .quiz-product-price");
      const productPriceArray = Array.from(productPrice).map(price => price.innerHTML);
      const productLink = this.querySelectorAll(".quiz-product-card .quiz-product-link a");
      const productLinkArray = Array.from(productLink).map(link => link.href);

      let clevertapData = {
        Current_Cart_Value : cartValue,
        Previous_Page : lastUrl,
        Suggested_PDP_Name : productNamesArray.join(","),
        Suggested_PDP_Price : productPriceArray.join(","),
        Suggested_PDP_Link : productLinkArray.join(","),
      }

      dataLayer.push({
        event: "Quiz_Complete",
        Current_Cart_Value : cartValue,
        Previous_Page : lastUrl,
        Suggested_PDP_Name : productNamesArray.join(","),
        Suggested_PDP_Price : productPriceArray.join(","),
        Suggested_PDP_Link : productLinkArray.join(","),
        clevertap : clevertapData
      });
    } else if (parameter=="View_Product") {
      let productForm = productCard.querySelector("product-form");
      let clevertapData = {
        PDP_Name : productForm.getAttribute("data-product-title"),
        Price : productForm.getAttribute("data-offer-price"),
        PDP_Link : productForm.getAttribute("data-product-link"),
        Cart_Value : cartValue,
        Variant_ID : productForm.getAttribute("data-variantid"),
        Variant_SKU : productForm.getAttribute("data-skuid"),
        PDP_Image : productForm.getAttribute("data-product-image"),
      }

      dataLayer.push({
        event: "Quiz_Suggested_View_Product_Viewed",
        PDP_Name : productForm.getAttribute("data-product-title"),
        Price : productForm.getAttribute("data-offer-price"),
        PDP_Link : productForm.getAttribute("data-product-link"),
        Cart_Value : cartValue,
        Variant_ID : productForm.getAttribute("data-variantid"),
        Variant_SKU : productForm.getAttribute("data-skuid"),
        PDP_Image : productForm.getAttribute("data-product-image"),
        clevertap : clevertapData
      });
    }
  }
}

customElements.define('product-quiz', ProductQuiz);

async function appBrewaddToCart() {
  let button = document.querySelector(".product-form__submit");
  const isApp = window.ReactNativeWebView || window.appbrew;

  if (isApp) {
    try {
      // setLoading(button, true)
      const result = await window.appbrewSDK.addToCart(
        `${button.getAttribute("data-handle")}`,
        `gid://shopify/ProductVariant/${button.getAttribute("data-varient-id")}`,
        1
      )
      showToast() // Show toast instead of alert
    } catch (error) {
      console.log(`Error: ${error.message}`)
    } finally {
      // setLoading(button, false);
      button.classList.remove("loading");
      button.querySelector(".loading-overlay__spinner").classList.add("hidden");
      button.setAttribute("aria-disabled","false")
      appBrewgotoCart();
    }
  }
}

async function appBrewgotoCart() {
  try {
    // setLoading(button, true)
    const result = await window.appbrewSDK.gotoLink({
      kind: 'screen',
      value: 'cart',
    })
  } catch (error) {
    console.error(`Error: ${error.message}`)
  } finally {
    // setLoading(button, false)
  }
}

async function appBrewgotoProduct(event) {
  let button = document.querySelector(".quiz-product-link");
  const isApp = window.ReactNativeWebView || window.appbrew;
  if (isApp) {
    event.preventDefault();
    try {
      const result = await window.appbrewSDK.gotoLink({
        kind: 'screen',
        value: 'products',
        params: {
          productHandle: `${button.getAttribute("data-handle")}`,
        },
    })
    } catch (error) {
      console.log(`Error: ${error.message}`)
    }
  }
}

class AppDownloadPopup extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.app-download-popup--button');
    this.button.addEventListener('click', this.addDatalayerEvent.bind(this));
  }

  connectedCallback() {
    this.hasScrolled = false;
    let quantityMessage = document.querySelector("#quantity-message");

    if (sessionStorage.getItem('show_apppop') == null) {
      this.setupScrollListener(quantityMessage);
    }

    this.querySelector(".close-icon").addEventListener("click", () => {
      this.classList.add("inactive");

      if (quantityMessage) {
        setTimeout(() => {
          quantityMessage.classList.remove("hidden");
        }, 800);
      }
      sessionStorage.setItem('show_apppop', 'false');
    });
  }

  setupScrollListener(quantityMessage) {
    window.addEventListener('scroll', () => {
      const shopByConcernSection = document.querySelector(".category-tab");
      const faqSection = document.querySelector(".layout-new-faq-section");
      const productGrid = document.querySelector(".grid__item.popup-trigger-product");

      if ((shopByConcernSection && this.isInView(shopByConcernSection)) ||
          (faqSection && this.isInView(faqSection)) || productGrid && this.isInView(productGrid)) {
        if (!this.hasScrolled) {
          this.showPopup(quantityMessage);
          this.hasScrolled = true;
        }
      }
    });
  }

  isInView(element) {
    const rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.top <= window.innerHeight / 2;
  }

  showPopup(quantityMessage) {
    setTimeout(() => {
      this.classList.remove("inactive");
      if (quantityMessage) {
        quantityMessage.classList.add("hidden");
      }
      this.handleOutsideClick(quantityMessage);
    }, 1);
  }

  handleOutsideClick(quantityMessage) {
    document.addEventListener('click', function (event) {
      if (!this.contains(event.target)) {
        this.classList.add("inactive");

        if (quantityMessage) {
          setTimeout(() => {
            quantityMessage.classList.remove("hidden");
          }, 800);
        }
        sessionStorage.setItem('show_apppop', 'false');
      }
    }.bind(this));
  }

  addDatalayerEvent() {
    const cartValue = document.querySelector(".totals__subtotal-value")?document.querySelector(".totals__subtotal-value").innerHTML:"";
    const currentPage = this.dataset.currentPage;
    const headerMessage = this.dataset.headerMessage;
    const description = this.dataset.description;

    const clevertapData = {
      'Current_Page': currentPage,
      'Cart_Value': cartValue,
      'Header_Msg': headerMessage,
      'Popup_Description': description
    }

    dataLayer.push({
      'event': "App_Download_Popup",
      'Current_Page': currentPage,
      'Cart_Value': cartValue,
      'Header_Msg': headerMessage,
      'Popup_Description': description,
      clevertap: clevertapData
    });
  }
}

customElements.define("app-download-popup", AppDownloadPopup);

document.addEventListener('DOMContentLoaded', function() {
  const stripButton = document.querySelector('.menu-drawer-strip-button a');
  
  if (stripButton) {
    stripButton.addEventListener("click",()=>{
      const cartValue = document.querySelector(".totals__subtotal-value")?document.querySelector(".totals__subtotal-value").innerHTML:"";
      const clevertapData = {
        Current_Page: stripButton.dataset.currentPage,
        Cart_Value: cartValue
      }
  
      dataLayer.push({
        event: "Hamburger_App_Download",
        Current_Page: stripButton.dataset.currentPage,
        Cart_Value: cartValue,
        clevertap: clevertapData
      });
    })
  }
});

// confetti shooter

window.confettiShooter = function () {
  function shootConfetti() {
    const canvas = document.createElement("canvas");
    document.body.appendChild(canvas);

    const canvasWidth = 640; 
    const canvasHeight = window.innerHeight;

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    canvas.style.position = "fixed";
    canvas.style.top = "0";
    canvas.style.right = "0";
    canvas.style.width = window.innerWidth>749?'30vw':'90%';;
    canvas.style.height = "100%";
    canvas.style.pointerEvents = "none";
    canvas.style.zIndex = "9999";
    canvas.style.transition = "opacity 1s ease-out";

    const ctx = canvas.getContext("2d");
    const confettiParticles = [];

    class Confetti {
      constructor() {
        this.x = canvasWidth / 2; 
        this.y = canvasHeight / 2;
        this.size = Math.random() * 8 + 3;
        this.shape = Math.floor(Math.random() * 3);
        this.color = `hsl(${Math.random() * 360}, 100%, 70%)`;
        this.speedX = (Math.random() - 0.5) * 10;
        this.speedY = (Math.random() - 0.5) * 10;
        this.rotation = Math.random() * 360;
        this.rotationSpeed = Math.random() * 6 - 3;
        this.opacity = 1;
        this.waveAngle = Math.random() * Math.PI * 2;
      }

      update() {
        this.waveAngle += 0.1;
        this.x += this.speedX + Math.sin(this.waveAngle) * 2;
        this.y += this.speedY + Math.cos(this.waveAngle) * 2;
        this.rotation += this.rotationSpeed;
        this.speedY += 0.1;
        this.opacity -= 0.01;

        if (this.opacity <= 0) {
          this.opacity = 0;
        }
      }

      draw() {
        ctx.save();
        ctx.globalAlpha = this.opacity;
        ctx.translate(this.x, this.y);
        ctx.rotate((this.rotation * Math.PI) / 180);
        ctx.fillStyle = this.color;

        if (this.shape === 0) {
          ctx.fillRect(-this.size / 2, -this.size / 2, this.size, this.size);
        } else if (this.shape === 1) {
          ctx.beginPath();
          ctx.arc(0, 0, this.size / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.beginPath();
          ctx.moveTo(0, -this.size / 2);
          ctx.lineTo(-this.size / 2, this.size / 2);
          ctx.lineTo(this.size / 2, this.size / 2);
          ctx.closePath();
          ctx.fill();
        }

        ctx.restore();
      }
    }

    function createConfetti() {
      for (let i = 0; i < 150; i++) {
        confettiParticles.push(new Confetti());
      }
    }

    function animateConfetti() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      confettiParticles.forEach((particle) => {
        particle.update();
        particle.draw();
      });

      if (confettiParticles.some((p) => p.opacity > 0)) {
        requestAnimationFrame(animateConfetti);
      } else {
        fadeOutCanvas();
      }
    }

    function fadeOutCanvas() {
      canvas.style.opacity = "0";
      setTimeout(() => {
        document.body.removeChild(canvas);
      }, 1000);
    }

    createConfetti();
    requestAnimationFrame(animateConfetti);
  }

  shootConfetti();
};

document.addEventListener("DOMContentLoaded", function(){
  const searchInputEl = document.querySelector("#st-search-box") || document.querySelector("#st-search");

  function addEventOnClickOfResults(searchInput){
    const searchResultWrapper = document.querySelector("#st-after-search");

    if (searchResultWrapper) {
      searchResultWrapper.addEventListener('click', function(){
        let clevertapData = {
          Search_Query: searchInput
        }
  
        dataLayer.push({
          event: "Search",
          Search_Query: searchInput,
          clevertap : clevertapData
        });
      })
    }
  }

  if (searchInputEl) {
    searchInputEl.addEventListener('keyup', (event) => {
      if (event.target.value !== "" && event.key === "Enter") {
        let clevertapData = {
          Search_Query: event.target.value
        }

        dataLayer.push({
          event: "Search",
          Search_Query: event.target.value,
          clevertap : clevertapData
        });
      }
    })

    searchInputEl.addEventListener('blur', (event) => {
      if (event.target.value !== "") {
        addEventOnClickOfResults(event.target.value);
      }
    })
  }
})

document.addEventListener("DOMContentLoaded", function(){
  const navigationTabList = document.querySelectorAll(".tab-col-link");

  navigationTabList.forEach((navigationTab) => {
    navigationTab.addEventListener("click", (event) => {

      async function fetchCartData() {
        try {
          const response = await fetch("/cart.js");
          const data = await response.json();

          const categoryName = navigationTab.dataset.categoryName;
          const categoryLink = navigationTab.dataset.categoryLink;
          const categoryImage = navigationTab.dataset.categoryImage;
          const cartValue = Math.round(data.total_price / 100);

          let clevertapData = {
            Category_Name: categoryName,
            Category_Link: categoryLink,
            Cart_Value: cartValue,
            Category_Image: categoryImage
          }

          dataLayer.push({
            event: "mobile_category_rail",
            Category_Name: categoryName,
            Category_Link: categoryLink,
            Cart_Value: cartValue,
            Category_Image: categoryImage,
            clevertap: clevertapData
          });
        } catch (error) {
          console.error("Failed to fetch cart data:", error);
        }
      }

      fetchCartData()
    })
  })
})

document.addEventListener("DOMContentLoaded", () => {
  const orderPopupButtons = document.querySelectorAll(".order_details-popup-btn");
  const orderDetailsPopup = document.querySelector(".order_details-popup");
  const orderDetails = orderDetailsPopup?.querySelector(".order_details-details");
  const closeButton = orderDetails?.querySelector(".order_details-close");
  const loader = orderDetails?.querySelector(".order_details-loader");
  const body = document.body;

  if (!orderPopupButtons.length || !orderDetailsPopup || !orderDetails || !loader) return;

  orderPopupButtons.forEach(button => {
    button.addEventListener("click", () => {
      const orderUrl = button.getAttribute("data-order-url");
      const orderStatus = button.getAttribute("data-order-status");
      const orderNumber = button.getAttribute("data-order-number");

      updateOrderDetails(orderUrl, orderStatus, orderNumber);
      orderDetailsPopup.classList.remove("hidden");

      setTimeout(() => {
        orderDetails.classList.add("active");
      }, 100);

      body.style.overflow = "hidden";
    });
  });

  function closePopup() {
    orderDetailsPopup.classList.add("hidden");
    orderDetails.innerHTML = '';
    orderDetails.appendChild(loader);
    orderDetails.appendChild(closeButton);
    orderDetails.classList.remove("active");
    body.style.overflow = "scroll";
  }

  orderDetailsPopup.addEventListener("click", () => {
    closePopup();
  });

  closeButton.addEventListener("click",()=>{
    closePopup();
  })
 
  orderDetails.addEventListener("click", event => {
    event.stopPropagation();
  });

  async function updateOrderDetails(orderUrl, orderStatus, orderNumber) {
    const orderTracking = document.querySelector("order-tracking-input");
    orderTracking?.updateOrderStatus(orderUrl, orderStatus, orderNumber, orderDetails);
  }
});

class ProductAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordions = [];
    this.scrollSections = [];
  }

  connectedCallback() {
    this.accordions = this.querySelectorAll(".key_accordionnew");
    this.scrollSections = this.querySelectorAll(".scroll-offer");

    this.setupAccordion();
    this.setupScrollDrag();
  }

  setupAccordion() {
    const closeAll = () => {
      this.accordions.forEach(btn => {
        btn.classList.remove('activenew');
        const panel = btn.nextElementSibling;
        if (panel) {
          panel.style.maxHeight = null;
        }
      });
    };

    this.accordions.forEach(btn => {
      btn.addEventListener("click", () => {
        const panel = btn.nextElementSibling;
        if (btn.classList.contains("activenew")) {
          btn.classList.remove("activenew");
          panel.style.maxHeight = null;
        } else {
          closeAll();
          btn.classList.add("activenew");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }

  setupScrollDrag() {
    if (screen.width <= 2500) return;

    this.scrollSections.forEach(slider => {
      let isDown = false;
      let startX, scrollLeft;

      slider.addEventListener("mousedown", e => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
      });

      slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
      });

      slider.addEventListener("mousemove", e => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 3;
        slider.scrollLeft = scrollLeft - walk;
      });
    });
  }
}

customElements.define("product-accordion", ProductAccordion);

class CustomVariantSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let variants = this.querySelectorAll(".product-variant");
    variants.forEach((variant)=>{
      variant.addEventListener("click",()=>{
        this.fetchProduct(variant.getAttribute("data-varient-id"),variant.getAttribute("data-product-handle"))
      })
    })
  }
  async fetchProduct(variantId,productHandle) {
    try {
      const cardProductUrl = `/products/${productHandle}?variant=${variantId}&view=product-card`;
      const response = await fetch(cardProductUrl);
      if (!response.ok) throw new Error('Failed to fetch product');
      let card = await response.text();
      this.closest(".grid__item").innerHTML=card;
    } catch (error) {
      console.error('Error fetching product card:', error);
    }
  }
}

customElements.define("custom-variant-selector", CustomVariantSelector);

if (!customElements.get("buy-again-button")) {
  class BuyAgainButton extends HTMLElement {
    constructor() {
      super();

      try {
        this.lineItems = JSON.parse(this.dataset.lineItems || "[]");
      } catch (e) {
        console.error("Invalid JSON in data-line-items:", e);
        this.lineItems = [];
      }

      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.button = this.querySelector("button");
      this.errorMsgEl = this.querySelector(".buy-again-error");

      if (this.button) {
        this.button.addEventListener("click", this.buyAgain.bind(this));
      }
    }

    showError(message) {
      if (this.errorMsgEl) {
        this.errorMsgEl.textContent = message;
        this.errorMsgEl.classList.remove("hidden");
      }
    }

    clearError() {
      if (this.errorMsgEl) {
        this.errorMsgEl.textContent = "";
        this.errorMsgEl.classList.add("hidden");
      }
    }

    async buyAgain() {
      this.clearError();

      if (!this.lineItems.length) {
        this.showError("No items found to reorder.");
        return;
      }

      const spinner = this.button.querySelector(".loading-overlay__spinner");
      const buyAgainText = this.button.querySelector(".button-text");

      this.button.disabled = true;
      spinner?.classList.remove("hidden");
      buyAgainText?.classList.add("hidden");

      try {
        const cartRes = await fetch("/cart.js");
        const cartData = await cartRes.json();
        const cartItemsMap = {};
        cartData.items.forEach(item => {
          cartItemsMap[item.variant_id] = item.quantity;
        });

        const filteredItems = [];

        for (const item of this.lineItems) {
          const existingQty = cartItemsMap[item.id] || 0;
          if (existingQty >= 4) continue;

          const qtyAllowed = 4 - existingQty;
          const finalQty = Math.min(item.quantity || 1, qtyAllowed);

          if (finalQty > 0) {
            filteredItems.push({ id: item.id, quantity: finalQty });
          }
        }

        if (!filteredItems.length) {
          this.showError("All items already have max quantity in your cart.");
          return;
        }

        const formData = {
          items: filteredItems
        };

        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender?.().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement?.(document.activeElement);
        }

        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(formData)
        });

        if (!res.ok) throw new Error("Failed to add to cart");

        const data = await res.json();
        this.cart?.renderContents?.(data);

        if (this.cart?.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }

      } catch (err) {
        console.error("Buy Again error:", err);
        this.showError("Some items couldn't be added. Please try again.");
      } finally {
        this.button.disabled = false;
        spinner?.classList.add("hidden");
        buyAgainText?.classList.remove("hidden");
      }
    }
  }

  customElements.define("buy-again-button", BuyAgainButton);
}

class FaqAccordion extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('.smooth-details');
    if (!this.details) return;
    this.summary = this.details.querySelector('summary');
    this.wrapper = this.details.querySelector('.content-wrapper');
    this.content = this.details.querySelector('.content');

    this.isAnimating = false;

    // If details is initially open, set height to content height
    if (this.details.hasAttribute('open')) {
      this.wrapper.style.height = `${this.content.offsetHeight}px`;
    } else {
      this.wrapper.style.height = '0px';
    }

    this.summary.addEventListener('click', this.handleSmoothEffect);
  }

  handleSmoothEffect = (e) => {
    e.preventDefault();
    if (this.isAnimating) return;

    const openDetails = document.querySelector(".smooth-details[open]");
    const isSame = openDetails === this.details;

    if (openDetails && !isSame) {
      const openWrapper = openDetails.querySelector(".content-wrapper");
      const openContent = openDetails.querySelector(".content");

      openWrapper.style.height = `${openContent.offsetHeight}px`;
      requestAnimationFrame(() => {
        openWrapper.style.height = '0px';
      });

      openWrapper.addEventListener('transitionend', () => {
        openDetails.removeAttribute('open');
        openWrapper.style.height = '0px';
      }, { once: true });
    }

    if (this.details.hasAttribute('open')) {
      this.isAnimating = true;
      this.wrapper.style.height = `${this.content.offsetHeight}px`;
      requestAnimationFrame(() => {
        this.wrapper.style.height = '0px';
      });

      this.wrapper.addEventListener('transitionend', () => {
        this.details.removeAttribute('open');
        this.isAnimating = false;
      }, { once: true });
    } else {
      this.isAnimating = true;
      this.details.setAttribute('open', '');
      this.wrapper.style.height = '0px';

      requestAnimationFrame(() => {
        this.wrapper.style.height = `${this.content.offsetHeight}px`;
      });

      this.wrapper.addEventListener('transitionend', () => {
        this.wrapper.style.height = 'auto';

        const rect = this.details.getBoundingClientRect();
        const isInView =
          rect.top >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);

        if (!isInView) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const offset = rect.top + scrollTop - (window.innerHeight * 0.3);

          window.scrollTo({
            top: offset,
            behavior: 'smooth'
          });
        }

        this.isAnimating = false;
      }, { once: true });
    }
  };

  disconnectedCallback() {
    if (this.summary) {
      this.summary.removeEventListener('click', this.handleSmoothEffect);
    }
  }
}

customElements.define('faq-accordion', FaqAccordion);

document.addEventListener("DOMContentLoaded", () => {
  const helpCategoriesSection = document.querySelector(".help-categories-section");
  const helpCategories = document.querySelectorAll(".help-categories--block, .help-recent-purchase");

  const handleSectionToggle = (triggerElement) => {
    const mapedSectionName = triggerElement.getAttribute("data-maped-section");
    const mapedSection = document.querySelector(`.account-faq-section[data-maped-block="${mapedSectionName}"]`);
    
    if (!mapedSectionName || !mapedSection) return;

    helpCategoriesSection.classList.add("hidden");
    mapedSection.classList.remove("hidden");

    const backButton = mapedSection.querySelector(".profile-page-back-button");
    backButton?.addEventListener("click", (event) => {
      event.preventDefault();
      helpCategoriesSection.classList.remove("hidden");
      mapedSection.classList.add("hidden");
    });
  };

  helpCategories.forEach((category) => {
    category.addEventListener("click", () => handleSectionToggle(category));
  });
});

document.addEventListener("DOMContentLoaded",()=>{
  const toastMessage = document.querySelector(".atc-toast-message");
  if (toastMessage){
    const viewCartBtn = toastMessage.querySelector(".atc-toast-message-button");
    const cartDrawer = document.querySelector("cart-drawer")
    if (viewCartBtn && cartDrawer) {
      viewCartBtn.addEventListener("click",()=>{
        cartDrawer.open();
        toastMessage.classList.remove("active")
      })
    } 
  }
})

// heder account hover and click functionality
let headerIconAccount = document.querySelector('#headerIconAccount');
if(headerIconAccount) {
  if(window.innerWidth > 990){
    headerIconAccount.addEventListener('mouseenter', ()=> {
      headerIconAccount.classList.add('open');
    });
    headerIconAccount.addEventListener('mouseleave', ()=> {
      headerIconAccount.classList.remove('open');
    });
  } else {
    headerIconAccount.addEventListener('click', ()=> {
      if(headerIconAccount.classList.contains('open')){
        headerIconAccount.classList.remove('open');
      }else{
        headerIconAccount.classList.add('open');
      }
    });
  }
}

class CustomerDataForm extends HTMLElement {
  constructor() {
    super();
    this.currTab = null;
  }

  connectedCallback() {
    this.closeButton = this.querySelector(".customer_data-popup-close");
    this.popupcontent = this.querySelector(".customer_data-popup")
    this.form = this.querySelector(".customer_data-form");
    this.submitButton = this.querySelector(".customer_data-submit-btn");
    this.finalErrorContainer = this.querySelector(".customer_data-form-third-tab .customer_data-form-error");
    this.successContainer = this.querySelector(".customer_data-form-success");
    this.dateErrorMessage = this.querySelector(".customer_data-form-second-tab .customer_data-form-error");
    this.loader = this.querySelector(".customer_data-submit-loader");
    this.tabs = [...this.querySelectorAll(".customer_data-form-tab")];
    this.currTab = this.querySelector(".customer_data-form-first-tab");

    this.bindEvents();

    window.addEventListener('scroll', () => {
      const shopByConcernSection = document.querySelector(".category-tab");
      if(shopByConcernSection && this.isInView(shopByConcernSection) && sessionStorage.getItem("show_customer_form") !== "false"){
        this.showPopup();
      } 
    });
  }

  bindEvents() {
    this.closeButton?.addEventListener("click", () => this.hidePopup());

    this.addEventListener("click", (event) => {
      if (event.target === this) this.hidePopup();
    });

    this.querySelectorAll(".customer_data-prev-btn").forEach((btn) =>
      btn.addEventListener("click", () =>
        this.showNextTab(btn.dataset.prev)
      )
    );

    this.querySelectorAll(".customer_data-save-btn").forEach((btn) =>
      btn.addEventListener("click", (e) => this.handleSave(e, btn))
    );

    this.submitButton?.addEventListener("click", (e) => {
      e.preventDefault();
      this.finalErrorContainer.textContent = "";
      if (this.validateForm()) this.submitForm();
    });
  }

  isInView(element) {
    const rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.top <= window.innerHeight / 2;
  }

  showPopup() {
    this.classList.remove("hidden");
    setTimeout(() => {
      this.popupcontent.classList.add("active");
    }, 200);
    document.body.style.overflow = "hidden";
  }

  hidePopup() {
    this.classList.add("hidden");
    this.popupcontent.classList.remove("active");
    sessionStorage.setItem("show_customer_form", "false");
    document.body.style.overflow = "auto";

    let firstTab = this.querySelector(".customer_data-form-first-tab");

    if (this.currTab != firstTab) {
      firstTab.classList.remove("hidden");
      this.currTab.classList.add("hidden");
      this.currTab = firstTab;
    }
  }

  handleSave(event, button) {
    event.preventDefault();
    if (button.closest(".customer_data-form-second-tab")) {
      const dob = this.form.querySelector("input[name=dob]")?.value.trim();
      const today = new Date().toISOString().split("T")[0];
      if (!dob) {
        return this.showMessage(this.dateErrorMessage, "Please select a valid date");
      }
      if (dob && dob >= today) {
        return this.showMessage(this.dateErrorMessage, "Date of birth cannot be in the future.");
      }
    }
    this.showNextTab(button.dataset.next);
  }

  showNextTab(index) {
    const tabs = ["", "first", "second", "third"];
    let tab = tabs[index] || "";

    const nextTab = this.querySelector(`.customer_data-form-${tab}-tab`);
    if (!nextTab) return;
    this.currTab?.classList.add("hidden");
    nextTab.classList.remove("hidden");
    this.currTab = nextTab;
  }

  validateForm() {
    const skincareGoals = [...this.querySelectorAll(".customer_data-form-third-tab input[type='checkbox']:checked")]
      .map(opt => opt.value);

    if (!skincareGoals.length) {
      this.showMessage(this.finalErrorContainer, "Please select at least one skincare goal.");
      return false;
    }
    return true;
  }

  async submitForm() {
    this.loader.classList.remove("hidden");

    const formData = new FormData(this.form);
    const skincareGoals = [...this.querySelectorAll(".customer_data-form-third-tab input[type='checkbox']:checked")]
      .map(opt => {
        formData.delete(opt.name);
        return opt.value;
      });

    formData.append("customerId", this.form.dataset.customerId || "");
    formData.set("birthdate", this.form.querySelector("input[name=dob]")?.value || "");
    formData.set("gender", this.querySelector("input[name=gender]:checked")?.value || "");
    formData.set("skincareGoal", skincareGoals.join(","));
    formData.append("storeName", "hyphen");

    try {
      const response = await fetch("https://mcaffeineCustomer.marmeto.com/api/update_customer_metafields", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();
      this.pushToClevertap({
        dob: formData.get("birthdate"),
        gender: formData.get("gender"),
        skincareGoals : skincareGoals
      });
      await this.showMessage(this.successContainer, "Data Saved Successfully");
      setTimeout(() => {
        this.hidePopup();
      }, 1000);
    } catch (error) {
      console.error(error);
      this.showMessage(this.finalErrorContainer, "Failed to submit. Please try again later.");
    } finally {
      this.loader.classList.add("hidden");
    }
  }

  pushToClevertap({ dob, gender, skincareGoals }) {
    clevertap.profile.push({
      "Site": {
        "Gender": gender,    
        "DOB": dob ? new Date(dob) : undefined,
        "Skincare Goal": skincareGoals.join(',') ,
      }
    });
  }

  showMessage(container, message, timeout = 3000) {
    if (!container) return;
    container.textContent = message;
    if (timeout) {
      setTimeout(() => { container.textContent = ""; }, timeout);
    }
  }
}

customElements.define("customer-data-form", CustomerDataForm);

document.addEventListener("DOMContentLoaded", () => {
  const customerForm = document.querySelector(".customer-form-section");
  const formSubmitButton = document.querySelector(".cf_submit-btn");

  if (!formSubmitButton || !customerForm) return;

  const loader = formSubmitButton.querySelector(".cf_submit-btn-loader");
  const buttonText = formSubmitButton.querySelector(".cf_submit-btn-text");
  const formMessage = customerForm.querySelector(".cf_messsage");

  function showMessage(text, type = "success", duration = 4000) {
    formMessage.textContent = text;
    formMessage.classList.remove("hidden", "error", "success");
    formMessage.classList.add(type);

    setTimeout(() => {
      formMessage.textContent = "";
      formMessage.classList.add("hidden");
      formMessage.classList.remove(type);
      formSubmitButton.disabled = false;
    }, duration);
  }

  function resetButton() {
    loader.classList.add("hidden");
    buttonText.classList.remove("hidden");
  }

  formSubmitButton.addEventListener("click", async (e) => {
    e.preventDefault();
    formSubmitButton.disabled = true;

    const email = customerForm.querySelector("input[name=email]")?.value.trim();
    const dob = customerForm.querySelector("input[name=dob]")?.value;
    const anniversary = customerForm.querySelector("input[name=anniversary]")?.value;
    const skincareGoals = [...customerForm.querySelectorAll("input[type='checkbox']:checked")].map(opt => opt.value);
    const gender = customerForm.querySelector("input[name=gender]:checked")?.value;

    if (!email || (!dob && !gender && !anniversary && skincareGoals.length === 0)) {
      showMessage("Please fill email and at least one other value.", "error");
      return;
    }

    if (customerForm.getAttribute("data-custom-id") === "") {
      showMessage("Please Log in before saving", "error");
      return;
    }

    const selectedDate = new Date(dob);
    const selectedAnniversary = new Date(anniversary);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    selectedAnniversary.setHours(0, 0, 0, 0);

    if (selectedAnniversary >= today) {
      showMessage("Anniversary date cannot be in the future.", "error");
      return;
    }

    if (selectedDate >= today) {
      showMessage("Date of birth cannot be today or in the future.", "error");
      return;
    }

    loader.classList.remove("hidden");
    buttonText.classList.add("hidden");

    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("customerId", customerForm.getAttribute("data-custom-id"));
      formData.set("birthdate", dob);
      formData.set("gender", gender);
      formData.set("skincareGoal", skincareGoals.join(","));
      formData.set("anniversary", anniversary);
      formData.append("storeName", "hyphen");

      const response = await fetch("https://mcaffeineCustomer.marmeto.com/api/update_customer_metafields", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      await response.json();

      clevertap.profile.push({
        "Site": {
          "Gender": gender,
          "DOB": dob ? new Date(dob) : undefined,
          "Anniversary": anniversary? new Date(anniversary):undefined,
          "Skincare Goal": skincareGoals.join(","),
        }
      });

      resetButton();
      showMessage("Data Saved Successfully", "success");

    } catch (error) {
      console.error(error);
      resetButton();
      showMessage("There was an error, please try again later", "error");
    }
  });
});

class OfferCommBar extends HTMLElement {
  connectedCallback() {
    this._observer = null;
    this._mutationObserver = null;
    this._seen = false;
    this._init();
  }

  _init() {
    const trigger = document.querySelector('.offer-container');
    if (trigger) {
      this._setupObserver(trigger);
    } else {
      this._waitForTrigger();
    }
  }

  _waitForTrigger() {
    this._mutationObserver = new MutationObserver((mutations, obs) => {
      const trigger = document.querySelector('.offer-container');
      if (trigger) {
        obs.disconnect();
        this._setupObserver(trigger);
      }
    });
    this._mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  _setupObserver(trigger) {
    this._observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this._seen = true;
          this.classList.remove('hidden');
        } else {
          if (entry.boundingClientRect.top < 0) {
            this.classList.remove('hidden');
          } else {
            this._seen = false;
            this.classList.add('hidden');
          }
        }
      });
    }, {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px -140px 0px'
    });

    this._observer.observe(trigger);

    const rect = trigger.getBoundingClientRect();
    if (rect.top < window.innerHeight - 100 && rect.bottom > 0) {
      this._seen = true;
      this.classList.remove('hidden');
    } else if (rect.top < 0) {
      this._seen = true;
      this.classList.remove('hidden');
    } else {
      this.classList.add('hidden');
    }
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
    if (this._mutationObserver) this._mutationObserver.disconnect();
  }
}

customElements.define('offer-comm-bar', OfferCommBar);

class CollectionCopyBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const banner = this.querySelector('.metafield_banner');
    if (!banner) return;

    this.popup = this.querySelector('.copy-popup');

    banner.addEventListener('click', () => this.copyCode(banner));
  }

  copyCode(banner) {
    const code = banner.dataset.collectionCode;
    const collectionName = banner.dataset.collectionName;
    if (!code) return;

    navigator.clipboard.writeText(code).then(() => {
      this.showPopup(`Code Copied..`);
      const clevertapData = {
        Collection_Name: collectionName || "",
        Coupon_Code: code
      };
      dataLayer.push({
        event: "Copy_Code",
        Collection_Name: collectionName || "",
        Coupon_Code: code,
        clevertap: clevertapData
      });
    }).catch(err => {
      console.error('Failed to copy code:', err);
    });
  }

  showPopup(message) {
    if (!this.popup) return;

    this.popup.textContent = message;
    this.popup.classList.add('show');
    clearTimeout(this.popupTimeout);

    this.popupTimeout = setTimeout(() => {
      this.popup.classList.remove('show');
    }, 2000);
  }
}

customElements.define('collection-copy-banner', CollectionCopyBanner);

if (!customElements.get('reorder-popup')) {
  class ReorderPopup extends HTMLElement {
    connectedCallback() {
      this.popupWrapper = document.querySelector('.reorder-popup-wrapper');
      this.tabButtons = this.popupWrapper.querySelectorAll('.reorder-tab');
      this.grids = this.popupWrapper.querySelectorAll('.reorder-product-grid');
      this.closeBtn = this.popupWrapper.querySelector('.reorder-close');
      this.innerTabButtons = this.popupWrapper.querySelectorAll('.inner-tab-button');
      this.innerTabContents = this.popupWrapper.querySelectorAll('.inner-tab-content');

      this.tabButtons.forEach(tab => {
        tab.addEventListener('click', () => {
          this.tabButtons.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');

          const category = tab.dataset.category;
          let activeProducts = []
          this.grids.forEach(g => {
            g.classList.remove('active');
            if (g.dataset.productsTab === category) {
              g.classList.add('active');
              let productCards = g.querySelectorAll(".card-wrapper");
              activeProducts = []
              productCards.forEach((product)=>{
                activeProducts.push(product.querySelector(".card__heading a").getAttribute("data-product-handle"))
              })
            }
          });

          const allUpsellGrids = this.popupWrapper.querySelectorAll('.upsell-grid');
          allUpsellGrids.forEach(grid => grid.classList.add("hidden"));

          const currentUpsell = this.popupWrapper.querySelector(`.upsell-grid[data-upsell-for="${category}"]`);
          if (currentUpsell) {
            currentUpsell.classList.remove("hidden");
          }

          const rootEl = this.popupWrapper.querySelector('.reorder-content');
          if (rootEl) {
            rootEl.scrollTo({
              top: 0
            });
          }
          
          const clevertapData = {
            sectionTitle: "Repurchase",
            Category_Image: tab.querySelector("img").getAttribute("src") || '',
            Category_Name : tab.getAttribute("data-category") || '',
            Product_Names : activeProducts,
          }

          dataLayer.push({
            event: "Category_Name",
            sectionTitle: "Repurchase",
            Category_Image: tab.querySelector("img").getAttribute("src") || '',
            Category_Name : tab.getAttribute("data-category") || '',
            Product_Names : activeProducts,
            clevertap: clevertapData
          });
        });
      });

      this.innerTabButtons.forEach(button => {
        button.addEventListener('click', () => {
          const tab = button.dataset.innerTab;

          const sectionId = tab === 'repurchase-products' ? '#products-section' : '#upsell-section';
          const section = document.querySelector(sectionId);
          const rootEl = this.popupWrapper.querySelector('.reorder-content');
          if (rootEl && section) {
            const headerOffset = this.querySelector(".reorder-header").offsetHeight;
            const sectionTop = section.offsetTop;

            // Scroll with offset
            rootEl.scrollTo({
              top: sectionTop - headerOffset,
              behavior: 'smooth'
            });
          }
        });
      });

      document.querySelectorAll('[data-reorder-trigger]').forEach(trigger => {
        trigger.addEventListener('click', () => this.openPopup());
      });

      this.closeBtn?.addEventListener('click', () => this.closePopup());

      this.popupWrapper.addEventListener('click', (e) => {
        if (e.target === this.popupWrapper) {
          this.closePopup();
        }
      });

      this.observeSections();

      if (localStorage.getItem('triggerReorderPopup') === 'true') {
        localStorage.removeItem('triggerReorderPopup');
        this.openPopup();
      }
    }

    observeSections() {
      const rootEl = this.popupWrapper.querySelector('.reorder-content');
      const productsSection = document.getElementById('products-section');
      const upsellSection = document.getElementById('upsell-section');
      if (!rootEl || !productsSection || !upsellSection) return;

      let lastActiveTab = null;

      rootEl.addEventListener('scroll', () => {
        const rootTop = rootEl.scrollTop;

        const productTop = productsSection.offsetTop;
        const upsellTop = upsellSection.offsetTop;

        // Calculate distance of each section's top from scroll top
        const distanceToProduct = Math.abs(rootTop - productTop);
        const distanceToUpsell = Math.abs(rootTop - upsellTop);

        const activeTab = distanceToUpsell < distanceToProduct ? 'upsell' : 'repurchase-products';

        if (activeTab !== lastActiveTab) {
          lastActiveTab = activeTab;
          let productList = this.tabActiveProducts(activeTab);

          const clevertapData = {
            Tab_Name: activeTab,
            Products_Name : productList
          }

          dataLayer.push({
            event: "Repurchase_Tabs",
            Tab_Name: activeTab,
            Products_Name : productList,
            clevertap: clevertapData
          });
        }

        this.innerTabButtons.forEach(btn => {
          btn.classList.toggle('active', btn.dataset.innerTab === activeTab);
        });
      });
    }

    openPopup() {
      const isLoggedIn = this.popupWrapper.dataset.loggedIn === 'true';
      if (!isLoggedIn) {
        kpHandleLogin(window.location.href);
        return;
      }

      this.popupWrapper?.classList.add('show');
      document.body.classList.add('reorder-overflow-hidden');

      const notifyPopup = document.querySelector('.notify-me-success-message-popup');
      if (notifyPopup) {
        notifyPopup.classList.add('z-106-b-4');
      }

      this.innerTabButtons.forEach(btn => btn.classList.remove('active'));
      const defaultTab = this.popupWrapper.querySelector('[data-inner-tab="repurchase-products"]');
      if (defaultTab) defaultTab.classList.add('active');
    }

    closePopup() {
      const popup = this.popupWrapper.querySelector('.reorder-popup');
      if (!popup) return;

      popup.classList.add('slide-out');

      popup.addEventListener(
        'transitionend',
        () => {
          this.popupWrapper?.classList.remove('show');
          popup.classList.remove('slide-out');
          document.body.classList.remove('reorder-overflow-hidden');
          const notifyPopup = document.querySelector('.notify-me-success-message-popup');
          if (notifyPopup) {
            notifyPopup.classList.remove('z-106-b-4');
          }
        },
        { once: true }
      );

      const clevertapData = {
        sectionTitle: "Repurchase",
      }

      dataLayer.push({
        event: "Close_Repurchase",
        sectionTitle: "Repurchase",
        clevertap: clevertapData
      });
    }

    tabActiveProducts(activeTab) {
      const productListWrapper = 
        activeTab === 'upsell' 
          ? this.querySelector(".upsell-grid:not(.hidden)") 
          : this.querySelector(".reorder-product-grid.active");

      if (!productListWrapper) {
        return [];
      }

      const productList = Array.from(
        productListWrapper.querySelectorAll(".card-wrapper")
      ).map(product => 
        product.querySelector(".card__heading a")?.getAttribute("data-product-handle")
      ).filter(Boolean);
      return productList;
    }
  }

  customElements.define('reorder-popup', ReorderPopup);
}

if (!customElements.get('reorder-login-button')) {
  class ReorderLoginButton extends HTMLElement {
    connectedCallback() {
      const redirectUrl = window.location.origin;
      const triggerPopup = this.dataset.triggerPopup === 'true';

      this.querySelector('button').addEventListener('click', () => {
        if (triggerPopup) {
          localStorage.setItem('triggerReorderPopup', 'true');
        }
        kpHandleLogin(redirectUrl);
      });
    }
  }

  customElements.define('reorder-login-button', ReorderLoginButton);
}

class ProductCardReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    let ratingCount = Math.round(this.getAttribute('data-score') * 10) / 10;
    this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7.94439 4.23407C7.8455 4.21896 7.76064 4.15555 7.71813 4.06499L6.27763 0.996167C6.16966 0.766145 5.8425 0.766129 5.7345 0.99614L4.2936 4.06501C4.25109 4.15556 4.16624 4.21896 4.06736 4.23407L0.823241 4.72976C0.581861 4.76664 0.483303 5.06105 0.653832 5.23583L3.02017 7.66103C3.08666 7.72918 3.11686 7.82485 3.10153 7.91882L2.54565 11.3279C2.50534 11.5751 2.76773 11.7599 2.9869 11.6387L5.86093 10.0497C5.95126 9.99973 6.06092 9.99973 6.15125 10.0497L9.02522 11.6387C9.24439 11.7599 9.50679 11.575 9.46646 11.3279L8.91021 7.91886C8.89488 7.82487 8.92508 7.72918 8.99159 7.66102L11.3583 5.23584C11.5288 5.06108 11.4303 4.76664 11.1889 4.72976L7.94439 4.23407Z" fill="#FEA203" stroke="#FEA203" stroke-width="0.48"/></svg>' + ratingCount;
  }
}

customElements.define("product-card-reviews" , ProductCardReviews);

if (!customElements.get("ingredient-info-tabs")) {
  class IngredientInfoTabs extends HTMLElement {
    constructor() {
      super();
      this.isMobile = window.matchMedia("(max-width: 749px)").matches;
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll(".tab-item");
      this.contents = this.querySelectorAll(".tab-content");
      this.popup = this.querySelector(".tabs-popup");
      this.overlay = this.querySelector(".tabs-popup-overlay");
      this.closeBtn = this.querySelector(".tabs-popup-close");

      this.addEventListener("click", this.handleClick.bind(this));
      window.addEventListener("resize", this.handleResize.bind(this));
    }

    handleResize() {
      this.isMobile = window.matchMedia("(max-width: 749px)").matches;
    }

    handleClick(e) {
      const tab = e.target.closest(".tab-item");
      if (!tab) return;

      const index = tab.dataset.tabIndex;

      this.scrollTabIntoView(tab);

      if (this.isMobile && !this.popup.classList.contains("active")) {
        this.openPopup(index);
      } else {
        this.activateTab(index);
      }
    }

    activateTab(index) {
      this.tabs.forEach(tab =>
        tab.classList.toggle("active", tab.dataset.tabIndex === index)
      );
      this.contents.forEach(content =>
        content.classList.toggle("active", content.dataset.tabContent === index)
      );
      this.updateCloseButtonPosition();
    }

    scrollTabIntoView(tab) {
      const list = tab.closest(".tabs-list");
      if (!list) return;

      tab.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center"
      });
    }

    openPopup(index) {
      document.body.style.overflow = "hidden";
      this.popup.classList.add("active");
      this.overlay.classList.add("active");
      this.closeBtn.classList.add("active");
      this.activateTab(index);

      const popupTab = this.popup.querySelector(
        `.tab-item[data-tab-index="${index}"]`
      );

      requestAnimationFrame(() => {
        if (popupTab) {
          this.scrollTabIntoView(popupTab);
        }
        this.updateCloseButtonPosition();
      });

      this.overlay.onclick = () => this.closePopup();
      this.closeBtn.onclick = () => this.closePopup();
    }

    closePopup() {
      this.popup.classList.remove("active");
      this.overlay.classList.remove("active");
      this.closeBtn.classList.remove("active");
      this.closeBtn.style.bottom = "";
      document.body.style.overflow = "";
    }

    updateCloseButtonPosition() {
      if (!this.popup.classList.contains("active")) return;

      requestAnimationFrame(() => {
        const popupHeight = this.popup.offsetHeight;
        const gap = 12;

        this.closeBtn.style.bottom = `${popupHeight + gap}px`;
      });
    }
  }

  customElements.define("ingredient-info-tabs", IngredientInfoTabs);
}

if (!customElements.get("copy-code-button")) {
  class CopyCodeButton extends HTMLElement {
    connectedCallback() {
      this.copyIcon = this.querySelector(".copy-icon");
      this.copiedIcon = this.querySelector(".copied-icon");

      this.addEventListener("click", () => {
        const code = this.dataset.code;
        if (!code) return;

        navigator.clipboard.writeText(code);

        this.copyIcon?.classList.add("hidden");
        this.copiedIcon?.classList.remove("hidden");

        setTimeout(() => {
          this.copyIcon?.classList.remove("hidden");
          this.copiedIcon?.classList.add("hidden");
        }, 1500);
      });
    }
  }

  customElements.define("copy-code-button", CopyCodeButton);
}

if (!customElements.get("accordion-tabs")) {
  class AccordionTabs extends HTMLElement {
    connectedCallback() {
      this.bindEvents();

      requestAnimationFrame(() => {
        this.setInitialHeights();
        this.initReadMore();
      });
    }

    bindEvents() {
      this.addEventListener("click", (e) => {

        const header = e.target.closest(".accordion-tabs__header");
        if (header && this.contains(header)) {
          const item = header.closest(".accordion-tabs__item");
          const body = item.querySelector(".accordion-tabs__body");

          const isOpen = item.classList.contains("is-open");

          if (isOpen) {
            body.style.maxHeight = "0px";
            item.classList.remove("is-open");
          } else {
            item.classList.add("is-open");
            body.style.maxHeight = body.scrollHeight + "px";

            this.initReadMore(body);
            this.updateAccordionHeight(
              body.querySelector(".accordion-tabs__panel.is-active")
            );
          }
          return;
        }

        const tab = e.target.closest(".accordion-tabs__tab");
        if (tab && this.contains(tab)) {
          const body = tab.closest(".accordion-tabs__body");
          const id = tab.dataset.tab;

          body.querySelectorAll(".accordion-tabs__tab").forEach(btn => {
            btn.classList.toggle("is-active", btn === tab);
          });

          body.querySelectorAll(".accordion-tabs__panel").forEach(panel => {
            const isActive = panel.dataset.tabPanel === id;
            panel.classList.toggle("is-active", isActive);

            if (isActive && panel.dataset.expanded === "true") {
              panel.classList.add("is-expanded");
              panel.querySelector(".accordion-tabs__read-toggle").textContent = "Read less";
            }
          });

          this.scrollTabIntoView(tab);

          this.initReadMore(body);
          this.updateAccordionHeight(
            body.querySelector(".accordion-tabs__panel.is-active")
          );
          return;
        }

        const toggle = e.target.closest(".accordion-tabs__read-toggle");
        if (toggle && this.contains(toggle)) {
          const panel = toggle.closest(".accordion-tabs__panel");
          const expanded = panel.classList.contains("is-expanded");

          panel.classList.toggle("is-expanded", !expanded);
          panel.dataset.expanded = (!expanded).toString();
          toggle.textContent = expanded ? "Read more" : "Read less";

          this.updateAccordionHeight(panel);
        }
      });
    }

    scrollTabIntoView(tab) {
      const nav = tab.closest(".accordion-tabs__nav");
      if (!nav) return;

      const navRect = nav.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();

      const scrollLeft =
        nav.scrollLeft +
        (tabRect.left - navRect.left) -
        (navRect.width / 2 - tabRect.width / 2);

      nav.scrollTo({
        left: scrollLeft,
        behavior: "smooth"
      });
    }

    setInitialHeights() {
      this.querySelectorAll(".accordion-tabs__item.is-open").forEach(item => {
        const body = item.querySelector(".accordion-tabs__body");
        if (!body) return;

        body.style.maxHeight = body.scrollHeight + "px";
      });
    }

    initReadMore(scope = this) {
      scope.querySelectorAll(".accordion-tabs__panel.is-active").forEach(panel => {
        const truncated = panel.querySelector(".accordion-tabs__content--truncated");
        const full = panel.querySelector(".accordion-tabs__content--full");
        const toggle = panel.querySelector(".accordion-tabs__read-toggle");

        if (!truncated || !full || !toggle) return;

        full.style.display = "block";

        const visibleHeight = truncated.clientHeight;
        const fullHeight = full.scrollHeight;

        full.style.display = "";

        toggle.hidden = !(fullHeight > visibleHeight);
      });
    }

    updateAccordionHeight(panel) {
      if (!panel) return;
      const body = panel.closest(".accordion-tabs__body");
      if (!body) return;

      body.style.maxHeight = body.scrollHeight + "px";
    }
  }

  customElements.define("accordion-tabs", AccordionTabs);
}

if (!customElements.get("clinical-reports")) {
  class ClinicalReports extends HTMLElement {
    connectedCallback() {
      this.accordion = this.querySelector('.clinical-reports-section__accordion');
      this.header = this.querySelector('.clinical-reports-section__header');
      this.content = this.querySelector('.clinical-reports-section__content');

      this.modal = this.querySelector('.clinical-reports-section__modal');
      this.modalOverlay = this.querySelector('.clinical-reports-section__modal-overlay');
      this.modalClose = this.querySelector('.clinical-reports-section__modal-close');

      if (this.dataset.open === 'true') {
        this.openAccordion();
      }

      this.header.addEventListener('click', () => this.toggleAccordion());

      this.querySelectorAll('.clinical-reports-section__btn--popup')
        .forEach(btn => {
          btn.addEventListener('click', () => {
            const card = btn.dataset.card;
            this.openModal(card);
          });
        });

      this.modalOverlay.addEventListener('click', () => this.closeModal());
      this.modalClose.addEventListener('click', () => this.closeModal());

      document.addEventListener('keydown', (e) => {
        if (e.key === "Escape") this.closeModal();
      });
    }

    openAccordion() {
      this.accordion.classList.add('is-active');
      this.content.style.maxHeight = this.content.scrollHeight + "px";
    }

    closeAccordion() {
      this.accordion.classList.remove('is-active');
      this.content.style.maxHeight = 0;
    }

    toggleAccordion() {
      this.accordion.classList.contains('is-active')
        ? this.closeAccordion()
        : this.openAccordion();
    }

    openModal(card) {
      this.querySelectorAll('.clinical-report-images')
        .forEach(el => el.style.display = 'none');

      const activeCard = this.querySelector(`.clinical-report-images[data-card="${card}"]`);
      if (activeCard) activeCard.style.display = 'block';

      this.modal.classList.add('is-active');
      document.body.style.overflow = "hidden";
    }

    closeModal() {
      this.modal.classList.remove('is-active');
      document.body.style.overflow = "";
    }
  }

  customElements.define('clinical-reports', ClinicalReports);
}

if (!customElements.get('review-scroll')) {
  class ReviewScroll extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.scrollToReviews.bind(this));
    }

    scrollToReviews() {
      const reviewSection = document.getElementById('judgeme_product_reviews');
      if (reviewSection) {
        reviewSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }

  customElements.define('review-scroll', ReviewScroll);
}

if (!customElements.get("custom-product-accordion")) {
  class CustomProductAccordion extends HTMLElement {
    connectedCallback() {
      this.bindEvents();
    }

    bindEvents() {
      this.addEventListener("click", (e) => {
        const header = e.target.closest(".product-accordion__header");
        if (!header) return;

        const item = header.closest(".product-accordion__item");
        const body = item.querySelector(".product-accordion__body");
        const isOpen = item.classList.contains("is-open");

        this.querySelectorAll(".product-accordion__item").forEach((el) => {
          el.classList.remove("is-open");
          const elBody = el.querySelector(".product-accordion__body");
          if (elBody) elBody.style.maxHeight = "0px";
        });

        if (!isOpen) {
          item.classList.add("is-open");
          body.style.maxHeight = body.scrollHeight + "px";
        }
      });
    }
  }

  customElements.define("custom-product-accordion", CustomProductAccordion);
}

if (!customElements.get('rapid-commerce-pincode')) {

  class RapidCommercePincode extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.rapid-commerce-pincode-input');
      this.button = this.querySelector('.rapid-commerce-pincode-button');
      this.message = this.querySelector('.rapid-commerce-pincode-message');
      this.sku = this.dataset.sku;
      this.productId = this.dataset.productId;
      this.productTitle = this.dataset.productTitle;
      this.defaultPincode = this.dataset.defaultPincode;
      this.lastOrderPincode = this.dataset.lastOrderPincode;

      if (!this.input || !this.button || !this.message) {
        console.warn('RapidCommercePincode: Missing required elements');
        return;
      }

      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/\D/g, '').slice(0, 6);
      });

      this.button.addEventListener('click', () => {
        this.checkPincode();
      });

      this.input.addEventListener('keypress', (e) => {
        if (e.key !== 'Enter') return;
        
        const pincode = this.input.value.trim();
        if (/^\d{6}$/.test(pincode)) {
          this.checkPincode();
        }
      });

      const savedPincode = localStorage.getItem('user_pincode');
      const isValid = (pin) => pin && /^\d{6}$/.test(pin.trim());

      let finalPincode = null;

      if (isValid(savedPincode)) {
        finalPincode = savedPincode;
      } else if (isValid(this.lastOrderPincode)) {
        finalPincode = this.lastOrderPincode;
      } else if (isValid(this.defaultPincode)) {
        finalPincode = this.defaultPincode;
      }

      if (finalPincode) {
        this.input.value = finalPincode;
        this.checkPincode();
      }
    }

    getQuantity() {
      const qtyInput = document.querySelector('input[name="quantity"]');
      if (!qtyInput) return 1;

      const qty = parseInt(qtyInput.value);
      return isNaN(qty) ? 1 : qty;
    }

    async checkPincode() {
      const pincode = this.input.value.trim();
      if (!pincode) {
        return this.setMessage('Please enter a pincode.', 'error');
      }

      if (!/^\d{6}$/.test(pincode)) {
        return this.setMessage('Enter a valid 6-digit pincode.', 'error');
      }

      const quantity = this.getQuantity();
      this.setMessage('Checking delivery options...', 'info');
      this.button.disabled = true;

      try {
        const response = await fetch(
          'https://shopify-promise.omnivio.io/api/v2/edd',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Token dc7de734f1b87e2080064d2ce3b802d1a5f5168aa53017b47b41fb3e96bae9d4'
            },
            body: JSON.stringify({
              zipcode: pincode,
              orderItems: [
                {
                  sku: this.sku,
                  quantity: quantity
                }
              ]
            })
          }
        );

        const data = await response.json();
        if (data.success) {
          const text = data.global_data?.text || 'Delivery available';
          this.setMessage(text, 'success');
          localStorage.setItem('user_pincode', pincode);

          if (window.clevertap && clevertap.event) {
            clevertap.event.push("pdp_estimated_delivery", {
              product_id: this.productId,
              product_title: this.productTitle,
              sku: this.sku,
              quantity: quantity,
              pincode: pincode,
              estimated_delivery: text
            });
          }
        } else {
          this.setMessage(
            'Delivery not available for this pincode.',
            'error'
          );
        }
      } catch (error) {
        console.error('Pincode API error:', error);
        this.setMessage(
          'Unable to check delivery right now.',
          'error'
        );
      }
      this.button.disabled = false;
    }

    setMessage(text, type) {
      const svgIcon = `
        <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 21C16.8954 21 16 20.1046 16 19C16 17.8954 16.8954 17 18 17C19.1046 17 20 17.8954 20 19C20 20.1046 19.1046 21 18 21Z" stroke="#71717A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7 21C5.89543 21 5 20.1046 5 19C5 17.8954 5.89543 17 7 17C8.10457 17 9 17.8954 9 19C9 20.1046 8.10457 21 7 21Z" stroke="#71717A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16 18H9" stroke="#71717A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15.75 18C15.75 18.4142 15.4142 18.75 15 18.75C14.5858 18.75 14.25 18.4142 14.25 18H15.75ZM2.75 5C2.75 5.41421 2.41421 5.75 2 5.75C1.58579 5.75 1.25 5.41421 1.25 5H2.75ZM14.25 18V7H15.75V18H14.25ZM11 3.75H3V2.25H11V3.75ZM2.75 4V5H1.25V4H2.75ZM3 3.75C2.86193 3.75 2.75 3.86193 2.75 4H1.25C1.25 3.0335 2.0335 2.25 3 2.25V3.75ZM14.25 7C14.25 5.20507 12.7949 3.75 11 3.75V2.25C13.6234 2.25 15.75 4.37665 15.75 7H14.25Z" fill="#71717A"/>
          <path d="M9 8.25C9.41421 8.25 9.75 8.58579 9.75 9C9.75 9.41421 9.41421 9.75 9 9.75V8.25ZM1 9.75C0.585787 9.75 0.25 9.41421 0.25 9C0.25 8.58579 0.585787 8.25 1 8.25V9.75ZM9 9.75H1V8.25H9V9.75Z" fill="#71717A"/>
          <path d="M9 11.25C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75V11.25ZM4 12.75C3.58579 12.75 3.25 12.4142 3.25 12C3.25 11.5858 3.58579 11.25 4 11.25V12.75ZM9 12.75H4V11.25H9V12.75Z" fill="#71717A"/>
          <path d="M20 11.25C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75V11.25ZM15 12.75C14.5858 12.75 14.25 12.4142 14.25 12C14.25 11.5858 14.5858 11.25 15 11.25V12.75ZM20 12.75H15V11.25H20V12.75Z" fill="#71717A"/>
          <path d="M2 16V17C2 17.5523 2.44772 18 3 18H5" stroke="#71717A" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M15 8L17.7112 8C18.0084 7.99991 18.2997 8.08603 18.5526 8.24873C18.8054 8.41142 19.0097 8.64425 19.1427 8.92111L20 12L21.9743 12.6581C22.5869 12.8623 23 13.4355 23 14.0811V16.5C23 17.3284 22.3284 18 21.5 18H20" stroke="#71717A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
      this.message.className = `rapid-commerce-pincode-message ${type}`;

      if (type === 'success') {
        this.message.innerHTML = `
          <div class="rapid-commerce-pincode-message-success">
            ${svgIcon} ${text}
          </div>
        `;
      } else {
        this.message.innerHTML = text;
      }
    }
  }

  customElements.define('rapid-commerce-pincode', RapidCommercePincode);
}

if (!customElements.get('newsletter-form')) {
  class NewsletterForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) {
        return;
      }

      this.form.addEventListener('submit', (event) => {
        sessionStorage.removeItem('newsletter_subscribed_sent');

        const emailInput = this.form.querySelector('[name="contact[email]"]');
        const email = emailInput?.value?.trim();

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        if (!email || !emailPattern.test(email)) {
          event.preventDefault();
          return;
        }

        sessionStorage.setItem('newsletter_email', email);
      });

      const successMessage = this.querySelector(
        '.footer-newsletter-form__message--success'
      );

      if (successMessage) {
        const email = sessionStorage.getItem('newsletter_email');

        const pushNewsletterEvent = () => {
          if (sessionStorage.getItem('newsletter_subscribed_sent')) {
            return;
          }

          if (email && window.clevertap?.event) {   
            window.clevertap.event.push('newsletter_subscribed', {
              email,
              source: 'Footer Newsletter',
              page_path: window.location.pathname,
              page_title: document.title,
              device_type: window.innerWidth < 768 ? 'mobile' : 'desktop'
            });

            sessionStorage.setItem(
              'newsletter_subscribed_sent',
              'true'
            );

            sessionStorage.removeItem('newsletter_email');
          } else {
            console.log(
              'CleverTap Event Not Sent - Missing Email or CleverTap'
            );
          }
        };

        if (document.readyState === 'complete') {
          pushNewsletterEvent();
        } else {
          window.addEventListener('load', pushNewsletterEvent, { once: true });
        }
      }
    }
  }

  customElements.define('newsletter-form', NewsletterForm);
}

class FeaturedBlogTracker extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const target = event.target.closest('[data-event]');
    if (!target || typeof clevertap === 'undefined') return;

    const commonData = {
      page_name: this.dataset.pageName,
      page_title: this.dataset.pageTitle,
      page_url: window.location.href,

      collection_name: this.dataset.collectionName,
      collection_handle: this.dataset.collectionHandle,

      section_name: 'Featured Blog',
      section_heading: this.dataset.sectionHeading,

      device_type: window.innerWidth < 768 ? 'Mobile' : 'Desktop'
    };

    switch (target.dataset.event) {

      case 'view-all':
        clevertap.event.push('Featured Blog View All Clicked', {
          ...commonData,
          clicked_text: target.dataset.text,
          destination_url: target.dataset.url
        });
        break;

      case 'blog-card':
        clevertap.event.push('Featured Blog Clicked', {
          ...commonData,

          article_title: target.dataset.title,
          article_handle: target.dataset.handle,
          article_url: target.dataset.url,

          article_id: target.dataset.articleId,
          blog_id: target.dataset.blogId,

          article_blog: target.dataset.blog,
          article_tags: target.dataset.tags,
          published_date: target.dataset.published,

          article_position: Number(target.dataset.index),
          total_articles: Number(target.dataset.total)
        });
        break;
    }
  }
}

if (!customElements.get('featured-blog-tracker')) {
  customElements.define('featured-blog-tracker', FeaturedBlogTracker);
}